/* Circadia chrome — cart drawer + lightweight interaction handlers.
   No libraries. CSS does the heavy lifting; this is just open/close. */

(function () {
  'use strict';

  // === /cart redirect REMOVED (Phase 3B-1 Step 3) ===
  // The /cart → home redirect from commit c8781fd was a temporary patch
  // while the cart page was rebuilt. Step 3 shipped the new cart page;
  // the redirect is no longer needed. Drawer auto-open after cart actions
  // continues to work via the universal /cart/add interceptor below.

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.from((root || document).querySelectorAll(sel)); }

  // === Cart drawer ===
  function openCart() {
    document.body.classList.add('cart-open');
    var d = $('[data-cart-drawer]');
    var o = $('[data-cart-overlay]');
    if (d) { d.classList.add('open'); d.setAttribute('aria-hidden', 'false'); }
    if (o) o.classList.add('open');

    // Phase 5-γ — populate cachedMe on first drawer-open for logged-in
    // customers off /cart, so the drawer credit notice can render on PDPs
    // / collections / etc. On /cart, initCartLoyalty already fetched /me.
    // Forward-references cachedMe + loyaltyFetchMe + syncDrawerCreditNotice
    // — all defined later in this IIFE, hoisted into closure scope.
    if (cachedMe === null && d && d.hasAttribute('data-customer-logged-in')) {
      loyaltyFetchMe()
        .then(function (me) {
          cachedMe = me;
          syncDrawerCreditNotice();
        })
        .catch(function () { /* swallow — notice stays hidden */ });
    }
  }
  function closeCart() {
    document.body.classList.remove('cart-open');
    var d = $('[data-cart-drawer]');
    var o = $('[data-cart-overlay]');
    if (d) { d.classList.remove('open'); d.setAttribute('aria-hidden', 'true'); }
    if (o) o.classList.remove('open');
  }

  // ─── Cart quantity change failure copy ──────────────────────────────────
  //
  // Rendered customer-facing text: no em dashes.
  // ─── SHARED sign-in copy for expired-session (401) handling ─────────────
  //
  // ONE string, exported on window.Circadia and read by every surface that can
  // 401: this file's cart controls, wholesale-order.js (5 endpoints),
  // wholesale-dashboard.js (2) and refer-a-friend.js (1). Batched deliberately:
  // the alternative is making the same copy decision four times and ending up
  // with four slightly different strings.
  //
  // Consumers read it at CALL time, inside a handler, never at load time. This
  // file is deferred like the others, so load order is not guaranteed, but by
  // the time a customer clicks anything window.Circadia is populated.
  //
  // Rendered customer-facing text: no em dashes.
  var SIGN_IN_REQUIRED =
    'Please sign in to your Circadia account first, then try again.';
  window.Circadia = window.Circadia || {};
  window.Circadia.SIGN_IN_REQUIRED = SIGN_IN_REQUIRED;

  var CART_CHANGE_SIGN_IN = SIGN_IN_REQUIRED;
  var CART_CHANGE_FAILED = 'Could not update the quantity. Please try again.';
  var CART_CHANGE_STALE =
    'Quantity updated, but this page did not refresh. Reload to see the new total.';

  /** The row's visible quantity element, on either surface. */
  function cartRowQtyEl(row) {
    return row ? row.querySelector('.bundle-stepper-val') : null;
  }

  /** Inline error slot, created on demand so no Liquid change is needed. It
   *  lives INSIDE the row, so a successful refreshCart replaces it along with
   *  the rest of the row and the message clears itself. */
  function cartRowError(row) {
    if (!row) return null;
    var el = row.querySelector('[data-cart-item-error]');
    if (!el) {
      el = document.createElement('div');
      el.className = 'cart-item-error';
      el.setAttribute('data-cart-item-error', '');
      el.setAttribute('role', 'alert');
      row.appendChild(el);
    }
    return el;
  }

  function showCartRowError(row, message) {
    var el = cartRowError(row);
    if (el) {
      el.textContent = message;
      el.hidden = false;
    }
  }

  function clearCartRowError(row) {
    var el = row && row.querySelector('[data-cart-item-error]');
    if (el) {
      el.textContent = '';
      el.hidden = true;
    }
  }

  /** Both steppers and Remove, so a slow round trip cannot be double-fired. */
  function cartRowControls(row) {
    if (!row) return [];
    return $$('[data-cart-qty-minus],[data-cart-qty-plus],[data-cart-remove]', row);
  }

  function setCartRowBusy(row, busy) {
    cartRowControls(row).forEach(function (c) { c.disabled = !!busy; });
  }

  // Update line item quantity via /cart/change.js, then re-fetch the
  // active cart surface (drawer or cart-page) via refreshCart(). The
  // refresher dispatches 'circadia:cart-changed' after swap so the
  // case-aggregation engine reconcile runs against the latest cart
  // state regardless of which surface refreshed.
  //
  // FAILURE HANDLING, added 2026-08-05. This had NO .catch() at all: a failed
  // change rejected with nothing handling it, so the UI never updated and the
  // customer got no explanation on the most-used control in the cart. Same
  // silent-failure class as the four cart bugs fixed this session.
  //
  // WHY res.ok IS CHECKED SEPARATELY FROM .catch(). fetch RESOLVES on a 4xx or
  // 5xx; it only rejects on a network-level failure (DNS, offline, aborted,
  // CORS). So a .catch() alone would have handled the offline case and silently
  // ignored every server rejection, which is the more likely of the two. The
  // status check is what makes this a real fix rather than a decorative one.
  //
  // The 401 branch reads res.status BEFORE res.json(), because an
  // expired-session response is not guaranteed to be JSON and a parse throw
  // would surface as the generic message instead of "sign in".
  //
  // NOT optimistic. These steppers never wrote the new quantity into the DOM;
  // they always waited for refreshCart to re-render. So on a failed change the
  // displayed number is ALREADY the server's value and there is nothing to
  // revert. `applied` distinguishes the one case where that is not true: the
  // change succeeded and the REFRESH failed, leaving the display stale. There
  // the number is left alone (the server really does have the new value) and
  // the copy says to reload, rather than lying in either direction.
  function changeLine(key, quantity, row) {
    var applied = false;
    var qtyEl = cartRowQtyEl(row);
    var prevQtyText = qtyEl ? qtyEl.textContent : null;
    clearCartRowError(row);
    setCartRowBusy(row, true);

    return fetch(window.routes.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) {
        if (r.status === 401) throw new Error('cart_change_unauthorized');
        if (!r.ok) throw new Error('cart_change_http_' + r.status);
        return r.json();
      })
      .then(function () {
        applied = true;
        return refreshCart();
      })
      .catch(function (err) {
        var message = err && err.message === 'cart_change_unauthorized'
          ? CART_CHANGE_SIGN_IN
          : applied
            ? CART_CHANGE_STALE
            : CART_CHANGE_FAILED;
        // Server state unchanged, so put the row back exactly as it was.
        if (!applied && qtyEl && prevQtyText !== null) qtyEl.textContent = prevQtyText;
        showCartRowError(row, message);
        if (window.console && window.console.warn) {
          console.warn('[cart-change] failed:', err && err.message ? err.message : err);
        }
      })
      // TERMINAL link, so the controls re-enable on success, on a server
      // rejection, and on a network error alike. Re-enabling only in .catch()
      // is the PDP add-to-cart bug (a4d4e12) and the wholesale Place Order bug
      // (c523229). .then() rather than .finally(), matching this file's idiom.
      // A no-op when refreshCart replaced the row: the nodes are detached.
      .then(function () { setCartRowBusy(row, false); });
  }

  // Re-fetch the rendered drawer markup via the Section Rendering API and
  // swap the overlay + drawer DOM in place. After swap, dispatch
  // 'circadia:cart-changed' so other listeners (case-aggregation.js) can
  // re-run the cart-state engine against the new line items.
  //
  // The section file at sections/cart-drawer.liquid is a 1-line stub that
  // renders the cart-drawer snippet — its only purpose is to give the
  // Section Rendering API a target for the snippet (since {% render %} in
  // layout.liquid is not fetchable on its own).
  function refreshDrawer() {
    return fetch(window.location.pathname + '?section_id=cart-drawer', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : Promise.reject(new Error('section_id fetch failed')); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newOverlay = doc.querySelector('[data-cart-overlay]');
        var newDrawer  = doc.querySelector('[data-cart-drawer]');
        var curOverlay = document.querySelector('[data-cart-overlay]');
        var curDrawer  = document.querySelector('[data-cart-drawer]');
        if (!newOverlay || !newDrawer || !curOverlay || !curDrawer) return;
        var wasOpen = document.body.classList.contains('cart-open');
        curOverlay.replaceWith(newOverlay);
        curDrawer.replaceWith(newDrawer);
        if (wasOpen) {
          newOverlay.classList.add('open');
          newDrawer.classList.add('open');
          newDrawer.setAttribute('aria-hidden', 'false');
        }
        // Sync the nav header's cart-count badge from the freshly-rendered
        // drawer's [data-cart-count] span. Both spans use the same
        // ({{ cart.item_count | prepend: '00' | slice: -2, 2 }}) format
        // so textContent copy is correct. The header section isn't
        // re-fetched here — that would wipe nav-dropdown state mid-
        // interaction; piggybacking on the drawer fetch keeps the cost
        // at zero extra HTTP. Defensive: if either selector is missing
        // (e.g. on a page without the nav rendered), leave the existing
        // bubble alone — stale beats broken.
        var freshCount = newDrawer.querySelector('[data-cart-count]');
        var navCount = document.querySelector('[data-nav-cart-count]');
        if (freshCount && navCount) {
          navCount.textContent = freshCount.textContent;
        }
      })
      .catch(function () { /* swallow — drawer will update on next page nav */ })
      .then(function () {
        // Fire after swap so listeners read fresh DOM. Always dispatched,
        // even on fetch failure, so case-aggregation.js can still re-query
        // /cart.js and re-run the engine on the latest cart state.
        document.dispatchEvent(new CustomEvent('circadia:cart-changed'));
      });
  }

  // Cart-page counterpart to refreshDrawer(). Re-fetches the cart-page
  // sections via the multi-section rendering endpoint and swaps both
  // into the DOM via replaceWith on [data-cart-page-items] /
  // [data-cart-page-footer].
  //
  // Section key gotcha (post-Phase-3 diagnostic): Shopify's ?sections=
  // parameter expects section TYPE names (the .liquid filename without
  // the extension), NOT the JSON-template keys. cart.json has keys
  // "cart-items" / "cart-footer" but the section TYPES are "main-cart-
  // items" / "main-cart-footer". Requesting by JSON key returns 200
  // with empty HTML for each entry (Shopify silently no-ops), which
  // bypassed the swap entirely and left the page stale until full
  // reload. Verified via the diagnostic logs in commit 8d9b715 —
  // {"cart-items":"","cart-footer":""}.
  //
  // Defensive no-op when neither cart-page section is in the DOM — the
  // refreshCart() router below should already gate this, but the early
  // return makes the function safe to call from anywhere.
  //
  // Nav bubble sync: cart-page sections don't carry the zero-padded
  // [data-cart-count] span the drawer uses, so we extract item_count
  // from [data-cart-page-count]'s "N items" text + re-format to match
  // header.liquid's ({{ cart.item_count | prepend: '00' | slice: -2,
  // 2 }}). One-shot piggyback, no extra /cart.js round-trip.
  //
  // Dispatches 'circadia:cart-changed' on completion (always, even on
  // fetch failure) so case-aggregation.js + the inventory-shortfall
  // handler re-run against the latest cart state — same contract as
  // refreshDrawer.
  function refreshCartPage() {
    var curItems  = document.querySelector('[data-cart-page-items]');
    var curFooter = document.querySelector('[data-cart-page-footer]');
    if (!curItems && !curFooter) {
      // Not on /cart — drawer path handles it.
      return Promise.resolve();
    }
    return fetch(window.location.pathname + '?sections=main-cart-items,main-cart-footer', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(new Error('sections fetch failed: ' + r.status)); })
      .then(function (data) {
        var parser = new DOMParser();
        var newItems = null;
        if (data['main-cart-items'] && curItems) {
          var doc = parser.parseFromString(data['main-cart-items'], 'text/html');
          newItems = doc.querySelector('[data-cart-page-items]');
          if (newItems) curItems.replaceWith(newItems);
        }
        if (data['main-cart-footer'] && curFooter) {
          var doc2 = parser.parseFromString(data['main-cart-footer'], 'text/html');
          var newFooter = doc2.querySelector('[data-cart-page-footer]');
          if (newFooter) curFooter.replaceWith(newFooter);
        }
        if (newItems) {
          var pageCount = newItems.querySelector('[data-cart-page-count]');
          var navCount  = document.querySelector('[data-nav-cart-count]');
          if (pageCount && navCount) {
            var m = pageCount.textContent.match(/\d+/);
            if (m) navCount.textContent = ('00' + parseInt(m[0], 10)).slice(-2);
          }
        }
      })
      .catch(function () { /* swallow — cart will update on next page nav */ })
      .then(function () {
        document.dispatchEvent(new CustomEvent('circadia:cart-changed'));
      });
  }

  // Refresh BOTH surfaces in parallel when both DOM contexts exist.
  // The drawer is rendered in layout.liquid on every page, so its DOM
  // is always present — refreshDrawer always fires so opening the
  // drawer later (after a /cart mutation) shows fresh state. When the
  // visitor is on /cart, [data-cart-page] is present and refreshCartPage
  // also fires so the visible cart-page surface stays current.
  //
  // Original Phase 3 routing picked ONE surface (cart-page or drawer)
  // based on context, which left the other stale until full reload —
  // the case-aggregation tier-progress bar + discount line stayed
  // stale on /cart because case-aggregation's reconcile() only fired
  // refreshDrawer, and drawer mutations didn't propagate to /cart.
  // Promise.all both removes the staleness on the unobserved surface
  // at the cost of one extra section-render HTTP per mutation when on
  // /cart — acceptable; the section render is small and parallel.
  function refreshCart() {
    var promises = [];
    if (document.querySelector('[data-cart-page]')) promises.push(refreshCartPage());
    promises.push(refreshDrawer());
    return Promise.all(promises);
  }

  // Expose both refresh helpers so case-aggregation.js (and any future
  // module) can request a re-render after applying a discount code via
  // /cart/update.js. refreshDrawer / refreshCartPage each dispatch
  // 'circadia:cart-changed' on completion; case-aggregation.js re-handles
  // that event guarded by the cart-attribute matching check to avoid
  // infinite loops.
  window.Circadia = window.Circadia || {};
  window.Circadia.refreshDrawer   = refreshDrawer;
  window.Circadia.refreshCartPage = refreshCartPage;
  window.Circadia.refreshCart     = refreshCart;

  // === Carousel arrows ===
  // Generic prev/next arrow nav for any [data-carousel] container with
  // a [data-carousel-scroll] child + optional [data-carousel-prev] /
  // [data-carousel-next] siblings. Currently used by the cart-page
  // cross-sell rail; reusable for future carousels (drawer cross-sell
  // strip in Phase 4-δ, possibly PDP "related items"). Click scrolls
  // by one card width with smooth animation; scroll listener toggles
  // .is-disabled at boundaries; arrows hide entirely (via the [hidden]
  // attribute) when content fits the viewport with no overflow.
  //
  // Re-init pattern: refreshCartPage() replaceWith()s the rail's parent
  // section, so the OLD rail's DOM (with its scroll listener) is
  // garbage-collected and the NEW rail needs fresh wiring. We listen
  // for circadia:cart-changed (dispatched at the end of each refresh)
  // and re-init then. Initial DOMContentLoaded init covers first-load
  // state.
  function initCarousels() {
    var carousels = document.querySelectorAll('[data-carousel]');
    for (var i = 0; i < carousels.length; i++) {
      (function (rail) {
        if (rail.dataset.carouselInited === '1') return;
        var scroll = rail.querySelector('[data-carousel-scroll]');
        var prev   = rail.querySelector('[data-carousel-prev]');
        var next   = rail.querySelector('[data-carousel-next]');
        if (!scroll) return;
        rail.dataset.carouselInited = '1';

        function update() {
          var hasOverflow = scroll.scrollWidth > scroll.clientWidth + 1;
          if (prev) prev.hidden = !hasOverflow;
          if (next) next.hidden = !hasOverflow;
          if (!hasOverflow) return;
          var atStart = scroll.scrollLeft <= 1;
          var atEnd   = scroll.scrollLeft >= scroll.scrollWidth - scroll.clientWidth - 1;
          if (prev) { prev.classList.toggle('is-disabled', atStart); prev.disabled = atStart; }
          if (next) { next.classList.toggle('is-disabled', atEnd);   next.disabled = atEnd; }
        }

        function cardWidth() {
          var firstCard = scroll.firstElementChild;
          if (!firstCard) return scroll.clientWidth;
          var gap = parseFloat(getComputedStyle(scroll).columnGap || getComputedStyle(scroll).gap) || 0;
          return firstCard.getBoundingClientRect().width + gap;
        }

        if (prev) prev.addEventListener('click', function () {
          scroll.scrollBy({ left: -cardWidth(), behavior: 'smooth' });
        });
        if (next) next.addEventListener('click', function () {
          scroll.scrollBy({ left: cardWidth(), behavior: 'smooth' });
        });
        scroll.addEventListener('scroll', update, { passive: true });
        window.addEventListener('resize', update);
        update();
      })(carousels[i]);
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCarousels);
  } else {
    initCarousels();
  }
  // Re-init after the cart-page footer section is swapped via refreshCartPage.
  // The OLD rail's data-carousel-inited flag is gone with its DOM; the NEW
  // rail starts clean.
  document.addEventListener('circadia:cart-changed', initCarousels);

  // Cart-page sync after case-aggregation engine reconcile.
  // case-aggregation.js dispatches 'circadia:case-aggregation-reconciled'
  // AFTER its own refreshDrawer + state mutation completes (inFlight
  // released). We refresh ONLY the cart-page sections here — the drawer
  // is already current from case-agg's own refresh path. Without this,
  // the cart page lags the engine by one mutation cycle: refreshCart's
  // section fetch on the user's click runs against pre-engine attrs,
  // the engine then mutates attrs server-side via case-aggregation.js,
  // but no second cart-page refresh fires unless the user clicks again.
  //
  // No loop concern: case-aggregation.js's dispatch is gated on
  // stateChanged (only fires when case 1+hasCode or case 3 actually
  // mutated state). Case 2 (already applied, short-circuit) doesn't
  // dispatch, so the cart-changed → reconcile → reconciled → refresh
  // cycle settles after one corrective iteration.
  document.addEventListener('circadia:case-aggregation-reconciled', function () {
    if (document.querySelector('[data-cart-page]')) {
      refreshCartPage().catch(function () { /* swallow */ });
    }
  });

  // === Cart-page loyalty card (Phase 4-β) ===
  // Loyalty display in the cart-page right column. Three runtime states
  // (logged-out is server-rendered; not touched by this code):
  //
  //   loading      — server-renders shimmer skeleton when {% if customer %}
  //   tier-1       — JS, forward-looking: "reach Steady to start earning 2%"
  //   tier-2-plus  — JS, earn preview computed from cart drinks at tier.rate
  //   error        — JS fallback if /me fetch fails (no CTA, soft copy)
  //
  // Cached `me` and the customer first name live in module scope so
  // re-computing the earn preview on circadia:cart-changed doesn't
  // re-fetch /me (only the cart contents changed, not the customer).
  //
  // Tier 1 = "In Rhythm" (0 cans, 0% rate, no earn yet).
  // Tier 2+ earn rates: 0.02 / 0.05 / 0.08 / 0.10 — from me.tierMetadata,
  // not hardcoded.
  var cachedMe = null;

  function loyaltyFetchMe() {
    return fetch('/apps/dashboard/customer/me', {
      headers: { 'Accept': 'application/json' },
      credentials: 'same-origin',
    }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    });
  }

  function formatCad(cents) {
    var dollars = Math.max(0, cents) / 100;
    return '$' + dollars.toFixed(2);
  }

  // ─── Held credit: one line, only when there IS held credit ──────────────
  //
  // /customer/me returns grossBalanceCents (includes credit still inside its
  // hold) and spendableCents (what the mint will actually grant). Every
  // actionable control is sized against SPENDABLE, because quoting gross was
  // the bug: a referral grant in its 30-day hold showed as an available
  // balance and Apply then answered "No credit available right now".
  //
  // Silently subtracting the held part would trade one confusing display for
  // another, so the difference is stated in ONE short line. Returns '' when
  // nothing is held, which is the common case, so the rendered output is
  // byte-identical to before this change.
  function heldCreditLine(me) {
    var held = (me && me.credit && me.credit.heldCents) || 0;
    if (held <= 0) return '';
    var when = '';
    var iso = me.credit.heldReleasesAt;
    if (iso) {
      var d = new Date(iso);
      if (!isNaN(d.getTime())) {
        when = d.toLocaleDateString('en-CA', { month: 'short', day: 'numeric' });
      }
    }
    return formatCad(held) + ' more available ' + (when || 'soon');
  }

  // Phase 5-γ — credit input helpers.
  //
  // clampCreditInputValue:  on every keystroke, clamp the typed value
  //                         to [0.01, max] where max is read from the
  //                         input's data-cart-credit-amount-max (cents).
  //                         Empty value left alone so mid-typing isn't
  //                         hijacked.
  // formatCreditInputValue: on blur, format to two decimals + re-clamp.
  //                         Empty / invalid → "0.00" so the field always
  //                         displays a normalized figure.
  function clampCreditInputValue(input) {
    var raw = input.value;
    if (raw === '') return;
    var n = parseFloat(raw);
    if (!Number.isFinite(n)) return;
    var maxCents = parseInt(input.getAttribute('data-cart-credit-amount-max') || '0', 10);
    var maxDollars = maxCents / 100;
    if (n > maxDollars) {
      input.value = maxDollars.toFixed(2);
    } else if (n < 0) {
      input.value = '0.01';
    }
  }
  function formatCreditInputValue(input) {
    var raw = input.value;
    if (raw === '' || raw == null) {
      input.value = '0.00';
      return;
    }
    var n = parseFloat(raw);
    if (!Number.isFinite(n) || n < 0) {
      input.value = '0.00';
      return;
    }
    var maxCents = parseInt(input.getAttribute('data-cart-credit-amount-max') || '0', 10);
    var maxDollars = maxCents / 100;
    if (n > maxDollars) n = maxDollars;
    input.value = n.toFixed(2);
  }

  // Phase 5-γ Commit 4 — case-agg detection. When CASE- is on cart, we
  // switch the credit row from "Apply to cart" mode to "Copy code to use
  // at checkout" mode. The /cart/update.js endpoint holds one code at a
  // time, so applying CC- on a CASE--present cart would clobber the case
  // discount — the copy flow leverages combinesWith=true at Shopify
  // Checkout to stack both codes instead.
  /** case_aggregation_pct from cart attributes, as an integer. Stale-prone by
   *  design (it is not cleared when something displaces the code), which is
   *  why it is only ever used to be MORE conservative about showing Copy. */
  function cartAttrCasePct(cart) {
    var attrs = (cart && cart.attributes) || {};
    var raw = attrs.case_aggregation_pct;
    var n = parseInt(raw, 10);
    return Number.isFinite(n) ? n : 0;
  }

  function detectCaseDiscount(cart) {
    return ((cart && cart.discount_codes) || []).some(function (d) {
      return d && d.applicable && d.code && d.code.indexOf('CASE-') === 0;
    });
  }
  function detectCreditCode(cart) {
    return ((cart && cart.discount_codes) || []).some(function (d) {
      return d && d.applicable && d.code && d.code.indexOf('CC-') === 0;
    });
  }

  // Phase 5-γ Commit 4 — applied credit cents = how much of the
  // customer's gross balance is currently allocated as a CC- discount
  // on the cart. The single-slot constraint keeps CASE- and CC- codes
  // from coexisting via /cart/update.js, but a Shopify AUTOMATIC
  // discount can still apply alongside the CC- code — and it lands in
  // cart.total_discount too. So we sum only the CC- code's own cart-
  // level allocation(s) rather than trusting raw total_discount, which
  // would otherwise inflate the applied-credit figure. Used to:
  //   - compute availableCents = balanceCents − appliedCreditCents
  //   - compute the "apply this much TOTAL" input ceiling
  //   - drive the no-op check on the click handler (skip API call if
  //     the customer hit Apply with the already-applied amount)
  function computeAppliedCreditCents(cart) {
    if (!detectCreditCode(cart)) return 0;
    // Sum the total_allocated_amount (cents) of the cart-level discount-
    // code application(s) whose title is the CC- code. Excludes automatic/
    // script discounts, which carry their own non-CC- application entries.
    var apps = (cart && cart.cart_level_discount_applications) || [];
    var ccCents = 0;
    var matched = false;
    for (var i = 0; i < apps.length; i++) {
      var app = apps[i];
      if (!app || app.type !== 'discount_code') continue;
      if (String(app.title || '').slice(0, 3).toUpperCase() !== 'CC-') continue;
      ccCents += app.total_allocated_amount || 0;
      matched = true;
    }
    // Fallback: if the payload didn't surface the CC- code as a cart-level
    // application, fall back to total_discount (correct in the common
    // single-discount case, where no automatic discount coexists).
    if (!matched) return (cart && cart.total_discount) || 0;
    return ccCents;
  }

  // Phase 5-γ Commit 4 — error display helpers. Errors render into the
  // [data-cart-credit-error] element inside whichever scope's credit
  // surface is active. The element lives inside the JS-rendered HTML and
  // is wiped on re-render (acceptable: errors auto-clear on user action
  // anyway).
  function showCreditError(scope, msg) {
    var root = scope === 'drawer'
      ? document.querySelector('[data-cart-credit-notice]')
      : document.querySelector('[data-cart-loyalty]');
    if (!root) return;
    var el = root.querySelector('[data-cart-credit-error]');
    if (!el) return;
    el.textContent = msg;
    el.hidden = false;
  }
  function hideCreditError(scope) {
    var root = scope === 'drawer'
      ? document.querySelector('[data-cart-credit-notice]')
      : document.querySelector('[data-cart-loyalty]');
    if (!root) return;
    var el = root.querySelector('[data-cart-credit-error]');
    if (!el) return;
    el.textContent = '';
    el.hidden = true;
  }

  // Phase 5-γ Commit 4 — POST /cart-credit mints + reserves a CC-{32hex}
  // code (engine ceiling = min(grossCents, cart_subtotal_cents)). Returns
  // a Promise resolving to { ok: true, code, cents } or { ok: false,
  // reason } so callers can branch on success vs error message.
  function mintCartCredit(chosenCents) {
    return fetch('/apps/dashboard/customer/cart-credit', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ cart_subtotal_cents: chosenCents }),
    }).then(function (r) {
      // 401 FIRST, and on the STATUS rather than the body. The proxy returns
      // { error: 'invalid app proxy request' }, which matches neither regex
      // below, so an expired session used to fall through to "Please retry"
      // -- advice that can never work. Status is authoritative; a future
      // wording change would silently break any string match. Checked before
      // r.json() because an expired-session response is not guaranteed to be
      // JSON, and a parse throw would surface as "Network error" instead.
      if (r.status === 401) {
        return {
          ok: false,
          reason: 'Please sign in to your Circadia account first. Your credit is still there.',
        };
      }
      return r.json().then(function (json) {
        if (r.ok && json && json.active_reservation && json.active_reservation.discount_code) {
          return {
            ok: true,
            code: json.active_reservation.discount_code,
            cents: json.active_reservation.amount_cents,
          };
        }
        // Engine returned a structured error (no_credit_available, etc.)
        // or HTTP 4xx/5xx. Map to a customer-friendly message.
        var reason = 'Couldn’t apply credit. Please retry.';
        if (json && json.error) {
          if (/no credit available/i.test(json.error)) {
            reason = 'No credit available right now.';
          } else if (/temporarily unavailable/i.test(json.error)) {
            reason = 'Discount service is temporarily unavailable. Please retry.';
          }
        }
        return { ok: false, reason: reason };
      });
    }).catch(function () {
      return { ok: false, reason: 'Network error. Please retry.' };
    });
  }

  // Phase 5-γ Commit 4 — DELETE /cart-credit releases the customer's
  // one-per-customer reservation row + deactivates the Shopify code.
  // Returns a Promise that always resolves (failures swallowed and
  // logged; the 72h sweep collects the row if DELETE fails).
  function releaseCartCredit() {
    return fetch('/apps/dashboard/customer/cart-credit', {
      method: 'DELETE',
      credentials: 'same-origin',
    }).then(function (r) {
      if (!r.ok && window.console && window.console.warn) {
        console.warn('[cart-credit] DELETE returned HTTP ' + r.status + '. Reservation may linger until expiry sweep');
      }
    }).catch(function (err) {
      if (window.console && window.console.warn) {
        console.warn('[cart-credit] DELETE failed:', err && err.message ? err.message : err);
      }
    });
  }

  // Phase 5-γ Commit 4 — MODE A apply flow. Mints CC- code + applies via
  // /cart/update.js + fires refreshCart. On a cart-side rejection of the
  // freshly-minted code (vanishingly rare), auto-rolls-back via DELETE
  // /cart-credit so the reservation row doesn't linger artificially.
  function applyCreditFromCart(chosenCents, scope) {
    scope = scope || 'cart';
    hideCreditError(scope);
    return mintCartCredit(chosenCents).then(function (mint) {
      if (!mint.ok) {
        showCreditError(scope, mint.reason);
        return;
      }
      return fetch((window.routes && window.routes.cart_update_url ? window.routes.cart_update_url : '/cart/update') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ discount: mint.code }),
      }).then(function (r) {
        if (!r.ok) throw new Error('cart/update.js HTTP ' + r.status);
        return r.json();
      }).then(function (cart) {
        // Validate the code was actually accepted by Shopify (mirrors the
        // promo-apply validation pattern). On rejection: roll back the
        // reservation so the customer's balance display isn't artificially
        // reduced until the 72h expiry sweep.
        var applied = (cart.discount_codes || []).some(function (d) {
          return d && d.applicable && d.code === mint.code;
        });
        if (!applied) {
          return releaseCartCredit().then(function () {
            showCreditError(scope, 'Couldn’t apply credit. Please retry.');
          });
        }
        return refreshCart();
      }).catch(function () {
        // Cart-side apply failed AFTER mint succeeded. Roll back.
        return releaseCartCredit().then(function () {
          showCreditError(scope, 'Couldn’t apply credit. Please retry.');
        });
      });
    });
  }

  // Phase 5-γ Commit 4 — MODE B copy flow. Mints CC- code + writes to
  // clipboard. Does NOT apply to cart, does NOT fire cart-changed. The
  // reservation persists until orders/paid consumes it (paste at
  // Shopify Checkout) or the 72h sweep collects it.
  function copyCreditCodeToClipboard(chosenCents, scope, button) {
    scope = scope || 'cart';
    hideCreditError(scope);
    return mintCartCredit(chosenCents).then(function (mint) {
      if (!mint.ok) {
        showCreditError(scope, mint.reason);
        return;
      }
      var code = mint.code;
      var originalLabel = button ? button.innerHTML : null;
      function flashCopied() {
        // Session flag first, so the pre-checkout line below flips to the
        // "Code copied" state in the same tick as the button feedback.
        markCreditCopiedThisSession();
        refreshCreditPreCheckout();
        if (!button) return;
        button.innerHTML = '✓ Copied!';
        button.disabled = true;
        setTimeout(function () {
          if (button) {
            button.innerHTML = originalLabel;
            button.disabled = false;
          }
        }, 2000);
      }
      // navigator.clipboard.writeText requires secure context + user
      // gesture. The click that fired this handler IS the user gesture,
      // and HTTPS is in place on livecircadia.ca. Reject paths surface
      // the code inline so the customer can long-press / select-copy.
      if (navigator.clipboard && navigator.clipboard.writeText) {
        return navigator.clipboard.writeText(code).then(flashCopied).catch(function () {
          showCreditError(scope, 'Couldn’t auto-copy. Code: ' + code + ' (long-press to copy)');
        });
      }
      showCreditError(scope, 'Couldn’t auto-copy. Code: ' + code + ' (long-press to copy)');
    });
  }

  function loyaltyEscapeHtml(s) {
    if (s == null) return '';
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  // Compute earn preview cents from /cart.js at the given rate (e.g.
  // 0.02 for Tier 2). Mirrors backend orders/paid allocation (commit
  // 6cbb253): CC- credit consumes non-Functional-Beverage (merch)
  // lines first, spilling over to drink lines only when total CC-
  // exceeds total merch gross. CASE- and other non-CC discounts
  // remain allocated proportionally per Shopify's cart-level
  // distribution.
  //
  // Math:
  //   drinks_gross = Σ item.original_line_price for product_type='Functional Beverage'
  //   merch_gross  = Σ item.original_line_price for everything else
  //   cart_gross   = cart.items_subtotal_price (pre-cart-discount subtotal)
  //   total_cc     = computeAppliedCreditCents(cart)   (CC- code's own allocation, not raw total_discount)
  //   non_cc_disc  = cart.total_discount - total_cc    (CASE-, promos, automatic)
  //
  //   // Merch-first CC- allocation to drinks:
  //   drinks_cc    = max(0, total_cc - merch_gross)
  //
  //   // Proportional non-CC allocation to drinks (Shopify-default):
  //   drinks_non_cc = floor(non_cc_disc × drinks_gross / cart_gross)
  //
  //   drinks_net   = max(0, drinks_gross - drinks_cc - drinks_non_cc)
  //   earn         = floor(drinks_net × rate)
  //
  // Why a re-implementation of backend allocation rather than reading
  // cart-side fields directly: cart.js doesn't expose per-line
  // discount_application_index, so we can't distinguish CC- from
  // CASE- allocations per line. Computing it ourselves from
  // cart.total_discount + computeAppliedCreditCents matches the
  // backend's view of net dollars charged. Display must mirror
  // backend accrual (orders/paid handler) or customers see one
  // figure on cart-page and a different one at "credit earned"
  // post-order.
  //
  // Math.floor per EC-001 (round-down avoids fractional-cent artifacts).
  function loyaltyComputeEarn(cart, rate) {
    if (!cart || !cart.items || !(rate > 0)) return 0;
    var drinksGrossCents = 0;
    var merchGrossCents = 0;
    for (var i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      var lineGross = item.original_line_price || 0;
      if (item.product_type === 'Functional Beverage') {
        drinksGrossCents += lineGross;
      } else {
        merchGrossCents += lineGross;
      }
    }
    if (drinksGrossCents <= 0) return 0;

    var totalCcCents = computeAppliedCreditCents(cart);
    // CC- merch-first: drinks only see the spillover.
    var drinksCcCents = totalCcCents > merchGrossCents
      ? totalCcCents - merchGrossCents
      : 0;

    // Non-CC discount = cart.total_discount minus the CC- portion.
    // Shopify-default proportional allocation to drinks.
    var totalDiscountCents = (cart.total_discount || 0);
    var nonCcDiscountCents = totalDiscountCents - totalCcCents;
    if (nonCcDiscountCents < 0) nonCcDiscountCents = 0; // defensive
    var cartGrossCents = cart.items_subtotal_price || 0;
    var drinksNonCcDiscountCents = cartGrossCents > 0
      ? Math.floor((nonCcDiscountCents * drinksGrossCents) / cartGrossCents)
      : 0;

    var drinksNetCents = drinksGrossCents - drinksCcCents - drinksNonCcDiscountCents;
    if (drinksNetCents < 0) drinksNetCents = 0;
    return Math.floor(drinksNetCents * rate);
  }

  function loyaltyTierRate(me) {
    if (!me || !me.tierMetadata) return 0;
    var current = me.tier && me.tier.current;
    for (var i = 0; i < me.tierMetadata.length; i++) {
      if (me.tierMetadata[i].tier === current) {
        return me.tierMetadata[i].creditBackRate || 0;
      }
    }
    return 0;
  }

  function loyaltyTierName(me, n) {
    if (!me || !me.tierMetadata) return '';
    for (var i = 0; i < me.tierMetadata.length; i++) {
      if (me.tierMetadata[i].tier === n) return me.tierMetadata[i].name;
    }
    return '';
  }

  // ─── Credit row: ONE definition, rendered on every tier ─────────────────
  //
  // Previously this lived inside loyaltyRenderTier2Plus, so a Tier 1
  // customer got NO way to spend credit on /cart while the drawer offered
  // one (renderDrawerCreditNotice has never had a tier gate). Tier governs
  // the EARN RATE, not the right to spend a balance: referral grants, admin
  // grants and commission conversions all land on Tier 1 accounts. Gating
  // spend on tier was the bug.
  //
  // Lifted rather than copied into both branches: this is money UI and two
  // copies would drift. Returns the markup plus the show flag so each tier
  // card can place it where its own layout needs (Tier 2+ puts it above the
  // auto-apply foot; Tier 1 has no foot and appends).
  function buildCreditRow(card, me, cart) {
    // Phase 5-γ credit row — apply-as-total semantics.
    //
    // Input value = desired TOTAL credit applied to the cart (not an
    // amount-to-add). System mints a fresh CC- code for that exact
    // total via the engine's UPSERT-replace, replacing any existing
    // applied amount. Two modes selected by case-discount state:
    //   MODE A (no CASE- on cart): apply directly via /cart/update.js.
    //   MODE B (CASE- on cart):    copy code to clipboard; customer
    //     pastes at Shopify Checkout where combinesWith=true lets it
    //     stack with the case discount (commit a062d3a).
    // Both modes use the same input + button bordered group. Only the
    // button label + action differs.
    // SPENDABLE, not gross: this figure is both the headline and the input
    // ceiling, and it must equal what the mint will grant.
    var balanceCents = (me.credit && me.credit.spendableCents) || 0;
    var cartTotalCents = (cart && cart.total_price) || 0;
    var appliedCreditCents = computeAppliedCreditCents(cart);
    var hasCreditCode = detectCreditCode(cart);
    var hasCaseDiscount = detectCaseDiscount(cart);
    // Clears the copied latch if CC- just left the cart (manual removal or
    // displacement by CASE-). See noteCreditCodeOnCart.
    noteCreditCodeOnCart(hasCreditCode);
    // maxTotalCents = "the maximum credit the customer could end up
    // applied to this cart" — capped by both their balance AND the cart's
    // gross value (cart.total_price is post-discount; add back what's
    // applied to get gross). Clicking Apply with this value zeroes the cart.
    var cartGrossCents = cartTotalCents + appliedCreditCents;
    var maxTotalCents = Math.max(0, Math.min(balanceCents, cartGrossCents));
    // Show the row whenever the customer has any credit AND any gross cart
    // value — even if they're fully applied (maxTotal === applied), so they
    // can still edit the input to reduce or use × Remove. Empty cart auto-
    // handled by the section's cart.item_count > 0 Liquid gate.
    var showCreditRow = balanceCents > 0 && cartGrossCents > 0;
    // ─── MODE A is suppressed whenever case pricing is IN PLAY ──────────────
    //
    // The Ajax cart holds ONE discount code. MODE A's Apply posts
    // {discount: 'CC-...'}, which REPLACES whatever is there, so applying
    // credit on a case-qualifying cart silently destroyed a percentage
    // discount worth more than the credit (15% of $240 = $36 lost to spend
    // $50). MODE B (Copy + paste at checkout) is the only affordance that
    // lets the customer have both, which is proven to work: Shopify checkout
    // accepts both codes because combinesWith permits it.
    //
    // Gated on AVAILABILITY, not on the code being applied, so a cart that
    // qualifies but has not minted yet also gets Copy. That closes the window
    // where credit could be applied before CASE- lands.
    //
    // Three signals, OR'd, deliberately conservative: erring toward Copy costs
    // a paste step, erring toward Apply costs the customer real money.
    //   1. a CASE- code is already on the cart
    //   2. the engine's last verdict says the cart qualifies
    //   3. the cart attribute says so (stale-prone, used ONLY as a hint while
    //      the first engine response is in flight)
    var caseVerdict =
      (window.Circadia &&
        window.Circadia.caseAggregation &&
        window.Circadia.caseAggregation.lastVerdict) ||
      null;
    var caseAvailable =
      hasCaseDiscount ||
      (caseVerdict && caseVerdict.discount_pct > 0) ||
      cartAttrCasePct(cart) > 0;
    var creditMode = caseAvailable ? 'copy' : 'apply';
    card.setAttribute('data-cart-credit-state', showCreditRow ? 'available' : 'hidden');
    card.setAttribute('data-cart-credit-mode', creditMode);

    // Bordered-group styling reused from .cart-promo-input. The error
    // placeholder lives inside the row so it gets wiped on every re-render
    // (acceptable — errors auto-clear on user retry anyway).
    //
    // data-cart-credit-applied-cents on the row lets the click handler
    // do the no-op check (skip API call if desiredTotal === applied).
    var maxTotalDollars = (maxTotalCents / 100).toFixed(2);
    var buttonHtml = creditMode === 'copy'
      ? '<button type="button" class="btn btn-ghost cart-promo-input-apply"' +
          ' data-cart-credit-copy>📋 Copy code</button>'
      : '<button type="button" class="btn btn-ghost cart-promo-input-apply"' +
          ' data-cart-credit-apply>Apply</button>';
    // Names the field ("discount box") rather than assuming the customer knows
    // one exists on the next page. Drops the old "Both ... will apply", which
    // reassured about something they had not yet worried about.
    var helperHtml = creditMode === 'copy'
      ? '<p class="cart-loyalty-credit-helper">' + CREDIT_PASTE_HELPER + '</p>'
      : '';
    // MODE B only. MODE A is self-completing and needs no reminder, so this
    // passes false there and the mount clears.
    renderCreditPreCheckout(
      showCreditRow ? balanceCents : 0,
      showCreditRow && creditMode === 'copy'
    );
    // Phase 5-γ Commit 4 (fix-2) — secondary line surfacing how much
    // remains vs how much is already applied. Only renders when
    // appliedCreditCents > 0; on a clean cart, only the headline
    // shows. Stays visible even when fully applied so the customer
    // can edit the input down to release some credit.
    var remainingHtml = '';
    if (appliedCreditCents > 0) {
      var remainingCents = Math.max(0, balanceCents - appliedCreditCents);
      remainingHtml =
        '<span class="cart-loyalty-credit-remaining" data-cart-credit-remaining>' +
          formatCad(remainingCents) + ' remaining (' + formatCad(appliedCreditCents) + ' applied)' +
        '</span>';
    }
    // Held-credit line. Empty string when nothing is held, so a customer with
    // no hold sees exactly what they saw before this change.
    var heldText = heldCreditLine(me);
    var heldHtml = heldText
      ? '<span class="cart-loyalty-credit-remaining" data-cart-credit-held>' + heldText + '</span>'
      : '';
    // Phase 5-γ Commit 4 (fix-2) — markup order: amount + controls
    // first (so they share row 1 via flex space-between), THEN the
    // wrap-forcing 100%-width siblings (remaining, helper, error).
    // The bordered controls group stays right-justified on the same
    // row as the amount headline regardless of partial-apply state.
    var creditRowHtml = showCreditRow
      ? '<div class="cart-loyalty-credit-row" data-cart-credit-row data-cart-credit-applied-cents="' + appliedCreditCents + '">' +
          '<span class="cart-loyalty-credit-amount" data-cart-credit-amount>' +
            formatCad(balanceCents) + ' credit available' +
          '</span>' +
          '<div class="cart-promo-input cart-loyalty-credit-controls">' +
            '<label class="visually-hidden" for="cart-loyalty-credit-input">Credit amount to apply</label>' +
            '<input type="number" inputmode="decimal" id="cart-loyalty-credit-input"' +
              ' class="cart-promo-input-field cart-loyalty-credit-input"' +
              ' min="0.01" max="' + maxTotalDollars + '" step="0.01"' +
              ' value="' + maxTotalDollars + '"' +
              ' data-cart-credit-input data-cart-credit-amount-max="' + maxTotalCents + '"' +
              ' aria-label="Credit amount to apply" />' +
            buttonHtml +
          '</div>' +
          remainingHtml +
          heldHtml +
          helperHtml +
          '<div class="cart-loyalty-credit-error" data-cart-credit-error role="alert" hidden></div>' +
        '</div>'
      : '';
    return { html: creditRowHtml, show: showCreditRow };
  }

  // Listeners must reattach every render: innerHTML replaced the input node.
  function wireCreditRow(card, showCreditRow) {
    if (showCreditRow) {
      var creditInput = card.querySelector('[data-cart-credit-input]');
      if (creditInput) {
        creditInput.addEventListener('input', function () {
          clampCreditInputValue(creditInput);
        });
        creditInput.addEventListener('blur', function () {
          formatCreditInputValue(creditInput);
        });
      }
    }
  }

  function loyaltyRenderTier1(card, me, cart) {
    var firstName = card.getAttribute('data-customer-first-name') || '';
    var nameBit = firstName ? loyaltyEscapeHtml(firstName) + ', y' : 'Y';
    var nextName = loyaltyTierName(me, 2) || 'Steady';
    var nextThreshold = (me.tier && me.tier.nextThreshold) || 20;
    var cans = (me.tier && me.tier.cansRolling12mo) || 0;
    var nextRate = 0;
    if (me.tierMetadata) {
      for (var i = 0; i < me.tierMetadata.length; i++) {
        if (me.tierMetadata[i].tier === 2) {
          nextRate = me.tierMetadata[i].creditBackRate || 0;
          break;
        }
      }
    }
    var rateLabel = Math.round(nextRate * 100) + '%';
    var pct = Math.min(100, Math.max(0, (cans / nextThreshold) * 100));
    var credit = buildCreditRow(card, me, cart);
    card.setAttribute('data-loyalty-state', 'tier-1');
    card.innerHTML =
      '<strong class="cart-loyalty-title">' + nameBit + 'ou’re building toward <em>' + loyaltyEscapeHtml(nextName) + '</em></strong>' +
      '<p class="cart-loyalty-body">Reach ' + nextThreshold + '+ cans in 12 months to start earning ' + rateLabel + ' back on every order.</p>' +
      '<div class="cart-loyalty-progress">' +
        '<div class="cart-loyalty-progress-track"><div class="cart-loyalty-progress-fill" style="width:' + pct.toFixed(1) + '%;"></div></div>' +
        '<div class="cart-loyalty-progress-meta"><span>' + cans + ' / ' + nextThreshold + ' cans</span><span>rolling 12 months</span></div>' +
      '</div>' +
      // Same credit row the Tier 2+ card renders. A Tier 1 customer can hold
      // a balance (referral / admin grant / commission conversion) and until
      // now had no way to spend it from /cart. No foot on this card, so the
      // row simply comes last.
      credit.html;
    wireCreditRow(card, credit.show);
  }

  function loyaltyRenderTier2Plus(card, me, cart) {
    var tierName = (me.tier && me.tier.name) || loyaltyTierName(me, me.tier && me.tier.current);
    var rate = loyaltyTierRate(me);
    var rateLabel = Math.round(rate * 100) + '%';
    var earnCents = loyaltyComputeEarn(cart, rate);
    var autoApply = me.credit && me.credit.autoApply;
    var footCopy = autoApply
      ? 'Credit auto-applies to your next order'
      : 'Credit available in your dashboard';

    // Shared credit row (see buildCreditRow). Also sets the card credit
    // state/mode attributes and drives the MODE B pre-checkout line.
    var credit = buildCreditRow(card, me, cart);
    var creditRowHtml = credit.html;
    // Recomputed locally for the foot suppression below; both are pure
    // reads of the cart, so this cannot drift from the row.
    var hasCreditCode = detectCreditCode(cart);
    var hasCaseDiscount = detectCaseDiscount(cart);

    // Phase 5-γ Commit 4 — suppress the auto-apply footer when CC- or
    // CASE- is on cart. The footer copy ("Credit auto-applies to your
    // next order" / "Credit available in your dashboard") frames credit
    // as a calm future-order setting. When the customer is actively
    // managing credit on THIS order (CC- applied, or in MODE B with
    // CASE- on cart), the footer's framing is misleading — the credit
    // row itself communicates current-order action.
    var suppressFoot = hasCreditCode || hasCaseDiscount;
    var footHtml = suppressFoot
      ? ''
      : '<div class="cart-loyalty-foot">' + footCopy + '</div>';

    card.setAttribute('data-loyalty-state', 'tier-2-plus');
    card.innerHTML =
      '<strong class="cart-loyalty-title">You’re earning ' + rateLabel + ' back at <em>' + loyaltyEscapeHtml(tierName) + '</em></strong>' +
      '<div class="cart-loyalty-earn">' +
        '<span class="cart-loyalty-earn-label">This order earns you</span>' +
        '<span class="cart-loyalty-earn-amount" data-cart-loyalty-earn>' + formatCad(earnCents) + '</span>' +
      '</div>' +
      creditRowHtml +
      footHtml;

    // Phase 5-γ — wire the credit-input clamp + blur-format handlers when
    // the credit row rendered. innerHTML replaced the previous input (if
    // any) so listeners must reattach to the fresh element each render.
    wireCreditRow(card, credit.show);
  }

  function loyaltyRenderError(card) {
    card.setAttribute('data-loyalty-state', 'error');
    card.innerHTML =
      '<strong class="cart-loyalty-title">Your tier info is taking a moment</strong>' +
      '<p class="cart-loyalty-body">Refresh the page or check back in a bit. Your credit is safe.</p>';
  }

  // Dispatch to the tier card. BOTH branches now need a cart, because both
  // render the credit row (the row is sized against cart gross value), so the
  // /cart.js fetch is hoisted above the tier check rather than living on the
  // Tier 2+ path only.
  function loyaltyRenderWithCart(card, me, cart) {
    var current = me && me.tier && me.tier.current;
    if (current === 1) loyaltyRenderTier1(card, me, cart);
    else loyaltyRenderTier2Plus(card, me, cart);
  }

  function loyaltyRender(card, me, cart) {
    // Re-fetch /cart.js for the earn preview rather than reusing a
    // snapshot: case-aggregation.js may have just mutated cart
    // attributes via /cart/update.js; we want the post-engine cart
    // state. Small cost (one /cart.js per render) is acceptable.
    //
    // Phase 5-γ Commit 4: accept an optional pre-fetched cart so the
    // initCartLoyalty path can do one /cart.js fetch + share it across
    // loyalty render, drawer notice, and the auto-fire gate check.
    if (cart) {
      loyaltyRenderWithCart(card, me, cart);
      return Promise.resolve();
    }
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(new Error('cart.js HTTP ' + r.status)); })
      .then(function (freshCart) { loyaltyRenderWithCart(card, me, freshCart); })
      .catch(function () {
        // /cart.js failed but /me succeeded: still render the tier card,
        // just show $0 earn rather than blank. An empty cart yields
        // cartGrossCents 0, so the credit row hides rather than misreporting.
        loyaltyRenderWithCart(card, me, { items: [] });
      });
  }

  // Phase 5-γ Commit 4 — once-per-mount flag. Auto-fire runs at most once
  // per cart-page mount even if the customer manually × removes the
  // credit afterward (treats their removal as intent to not auto-re-apply
  // until they refresh the page).
  var autoFireConsumed = false;

  function initCartLoyalty() {
    var card = document.querySelector('[data-cart-loyalty][data-loyalty-state="loading"]');
    if (!card) return; // logged-out (server-rendered) or not on /cart
    loyaltyFetchMe()
      .then(function (me) {
        cachedMe = me;
        // Phase 5-γ Commit 4 — single /cart.js fetch threaded through:
        //   (1) loyalty card render
        //   (2) drawer credit notice render
        //   (3) auto-fire gate evaluation
        // The Tier-1 path doesn't need cart for render but we still fetch
        // so the drawer notice + auto-fire have what they need.
        return fetch('/cart.js', { credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.json() : null; })
          .catch(function () { return null; })
          .then(function (cart) {
            loyaltyRender(card, me, cart || { items: [] });
            syncDrawerCreditNotice(cart);
            // Phase 5-γ Commit 4 — auto-fire (MODE A only).
            // Apply-as-total: post the full maxTotalCents as the desired
            // total. Engine mints CC- for that amount.
            if (autoFireConsumed) return;
            if (!cart || !cart.items || cart.items.length === 0) return;
            var autoApply = me && me.credit && me.credit.autoApply === true;
            if (!autoApply) return;
            // Auto-fire MINTS, so its ceiling is spendable, never gross.
            var balanceCents = (me && me.credit && me.credit.spendableCents) || 0;
            if (balanceCents <= 0) return;
            // Skip when the customer has already chosen — any CC- on cart
            // means they (or auto-fire on a prior session) already acted.
            if (detectCreditCode(cart)) return;
            // MODE B (CASE- on cart) — never auto-write to clipboard. The
            // customer must explicitly click Copy.
            if (detectCaseDiscount(cart)) return;
            // No CC- applied in this branch, so cartGross == cart.total_price.
            var cartTotalCents = cart.total_price || 0;
            var maxTotalCents = Math.min(balanceCents, cartTotalCents);
            if (maxTotalCents <= 0) return;
            // Flip the flag BEFORE firing so a failure doesn't allow a
            // future trigger to re-attempt mid-session.
            autoFireConsumed = true;
            applyCreditFromCart(maxTotalCents, 'cart');
          });
      })
      .catch(function (err) {
        if (window.console && window.console.warn) {
          console.warn('[cart-loyalty] /me fetch failed:', err && err.message ? err.message : err);
        }
        loyaltyRenderError(card);
      });
  }

  // Phase 5-γ — drawer credit notice (separate from the loyalty card on
  // /cart). The drawer renders on every page (theme.liquid); on non-/cart
  // pages, openCart's lazy-fetch hook populates cachedMe + fires the first
  // render. On /cart, initCartLoyalty above does the initial render. In
  // both cases, the cart-changed listener at the bottom of this block
  // keeps the notice in sync across drawer/cart-page edits.
  function renderDrawerCreditNotice(me, cart) {
    var notice = document.querySelector('[data-cart-credit-notice]');
    if (!notice) return; // drawer not in DOM (empty cart Liquid gate, or logged-out)
    // Spendable: the drawer's Copy button mints against this figure.
    var balanceCents = (me && me.credit && me.credit.spendableCents) || 0;
    var cartTotalCents = (cart && cart.total_price) || 0;
    var appliedCreditCents = computeAppliedCreditCents(cart);
    var hasCreditCode = detectCreditCode(cart);
    var hasCaseDiscount = detectCaseDiscount(cart);
    var cartGrossCents = cartTotalCents + appliedCreditCents;
    var maxTotalCents = Math.max(0, Math.min(balanceCents, cartGrossCents));
    // Phase 5-γ Commit 4 — drawer gate matches the cart-page gate:
    // show when the customer has any credit AND any gross cart value.
    // The Liquid wrapper already gates the placeholder on
    // {% if customer and cart.item_count > 0 %} so empty/logged-out
    // never reach here.
    if (balanceCents <= 0 || cartGrossCents <= 0) {
      notice.hidden = true;
      notice.innerHTML = '';
      renderCreditPreCheckout(0, false);
      return;
    }
    notice.hidden = false;
    // Held-credit line, shared by both drawer modes. '' when nothing is held,
    // so the common case renders exactly as it did before.
    var drawerHeldText = heldCreditLine(me);
    var drawerHeldHtml = drawerHeldText
      ? '<span class="cart-drawer-credit-held">' + drawerHeldText + '</span>'
      : '';
    // Phase 5-γ Commit 4 — drawer is the discovery surface; cart-page
    // is the action surface. MODE A shows a navigate-to-cart link
    // (manual apply lives on /cart). MODE B shows an inline Copy
    // button mints maxTotalCents (no input here — partial requires
    // /cart). Both reservations persist for paste at Shopify Checkout
    // where combinesWith=true allows stacking with the CASE- code.
    // Same availability test as the cart page, so the two surfaces cannot
    // disagree about which mode the customer is in. See the note at the
    // cart-page creditMode derivation.
    var drawerCaseVerdict =
      (window.Circadia &&
        window.Circadia.caseAggregation &&
        window.Circadia.caseAggregation.lastVerdict) ||
      null;
    var drawerCaseAvailable =
      hasCaseDiscount ||
      (drawerCaseVerdict && drawerCaseVerdict.discount_pct > 0) ||
      cartAttrCasePct(cart) > 0;
    if (drawerCaseAvailable) {
      notice.innerHTML =
        '<span class="cart-drawer-credit-amount">💳 ' + formatCad(balanceCents) + ' credit</span>' +
        '<button type="button" class="cart-drawer-credit-copy"' +
          ' data-cart-credit-copy data-cart-credit-amount-max="' + maxTotalCents + '">' +
          '📋 Copy' +
        '</button>' +
        drawerHeldHtml +
        // Previously the drawer said NOTHING here while explaining itself in
        // every easier state. Same string as the cart page so the two stop
        // disagreeing.
        '<p class="cart-drawer-credit-helper">' + CREDIT_PASTE_HELPER + '</p>' +
        '<div class="cart-drawer-credit-error" data-cart-credit-error role="alert" hidden></div>';
      renderCreditPreCheckout(balanceCents, true);
    } else {
      // MODE A drawer — even when CC- is partially applied on cart,
      // navigation to /cart is the right action (manage the existing
      // applied amount via the cart-page input). data-cart-close is
      // handled by the existing close handler which skips
      // preventDefault for <a href> so the navigation proceeds while
      // closing the drawer in the same tick.
      notice.innerHTML =
        '<span class="cart-drawer-credit-amount">💳 ' + formatCad(balanceCents) + ' credit available</span>' +
        drawerHeldHtml +
        '<a href="/cart" class="cart-drawer-credit-cta" data-cart-close>View cart to apply &rarr;</a>' +
        '<div class="cart-drawer-credit-error" data-cart-credit-error role="alert" hidden></div>';
      // MODE A is self-completing (Apply puts credit on the cart), so the
      // pre-checkout reminder is not needed and is cleared.
      renderCreditPreCheckout(0, false);
    }
  }

  // ─── Credit copy-and-paste UX (shared by drawer + cart page) ────────────
  //
  // MODE B asks the customer to do something on a page we do not control: the
  // Ajax cart holds ONE code, CASE- has it, so credit has to be pasted at
  // Shopify Checkout. The money-losing failure is the customer who never
  // copies, proceeds, and silently pays more. These strings and the session
  // flag below exist to make the necessity visible before they leave.

  /** Same helper on BOTH surfaces. The drawer previously said nothing at all
   *  in MODE B while explaining itself in every easier state. */
  var CREDIT_PASTE_HELPER =
    'Paste in the discount box at checkout · Your case discount stays too';
  var CREDIT_PRECHECKOUT_UNCOPIED = ' credit to add at checkout.';
  var CREDIT_PRECHECKOUT_COPIED =
    'Code copied. Paste it in the discount box at checkout.';

  // ─── "copied this session" ───────────────────────────────────────────────
  //
  // sessionStorage, NOT localStorage: this is per-session UI state and must
  // die with the tab, never persist as a preference.
  //
  // WHY NOT A MODULE VARIABLE: the requirement is that it survive a cart
  // re-render, and a variable would. But the drawer and /cart are separate
  // page loads, so a customer who copies in the drawer and then navigates to
  // the cart page would be told again that they have credit to add, which is
  // wrong and is exactly the confusion this is meant to remove. sessionStorage
  // survives that navigation and a reload, and is cleared when the tab closes.
  //
  // Wrapped in try/catch because Safari private mode throws on access. A
  // throw degrades to "not copied", which shows the reminder rather than
  // suppressing it, which is the safe direction.
  var CREDIT_COPIED_KEY = 'circadia_credit_copied';
  function creditCopiedThisSession() {
    try {
      return window.sessionStorage.getItem(CREDIT_COPIED_KEY) === '1';
    } catch (_) {
      return false;
    }
  }
  function markCreditCopiedThisSession() {
    try {
      window.sessionStorage.setItem(CREDIT_COPIED_KEY, '1');
    } catch (_) {
      /* private mode; the reminder simply keeps showing */
    }
  }
  function clearCreditCopiedThisSession() {
    try {
      window.sessionStorage.removeItem(CREDIT_COPIED_KEY);
    } catch (_) {
      /* private mode; nothing was stored to clear */
    }
  }

  // Has a CC- code been observed on the cart on a PREVIOUS render?
  //   null  = unknown (first render this page load)
  //   true  = it was there
  //   false = it was not
  //
  // The latch records "I clicked copy", which is not the same as "my credit
  // is handled". It has to clear when the code it refers to leaves the cart,
  // in two cases: the customer removes the discount (the reservation is
  // released, so the code is dead), and case aggregation DISPLACES CC- with
  // CASE- (the documented recovery is that they re-copy and paste at
  // checkout, and that recovery depends on the reminder they were not
  // getting).
  //
  // WHY A TRANSITION AND NOT A STATE. "MODE B with no CC- on the cart" looks
  // like the obvious signal but is wrong: in MODE B the code is DELIBERATELY
  // never put on the Ajax cart (the customer pastes it at Shopify Checkout),
  // so that test is true immediately after every successful copy and would
  // clear the latch instantly, restoring the nagging this was built to stop.
  // Only a true -> false transition means a code actually left the cart.
  //
  // null -> false is NOT a transition: that is just the first render of a
  // page with no credit applied. Navigating drawer -> /cart resets this to
  // null, which is correct, because a fresh page load has observed nothing.
  //
  // Read from cart.discount_codes each render, so it tracks the authoritative
  // cart rather than becoming another proxy for it.
  var creditCodeWasOnCart = null;
  function noteCreditCodeOnCart(hasCreditCode) {
    if (creditCodeWasOnCart === true && !hasCreditCode) {
      clearCreditCopiedThisSession();
    }
    creditCodeWasOnCart = hasCreditCode;
  }

  // Last-known MODE B state, so the pre-checkout mount can be refreshed on a
  // Copy click without re-fetching /cart.js or rebuilding the credit row.
  var creditPreCheckoutState = { balanceCents: 0, isCopyMode: false };

  /**
   * Fill (or clear) the pre-checkout mounts that sit directly above the
   * Checkout button on both surfaces.
   *
   * Writes textContent, never innerHTML: the only dynamic part is a
   * server-derived money string, and textContent removes any question of
   * injection.
   *
   * Silent unless the customer is in MODE B with spendable credit, so a
   * customer with no credit sees nothing and the quiet default stays quiet.
   */
  function renderCreditPreCheckout(balanceCents, isCopyMode) {
    creditPreCheckoutState = {
      balanceCents: balanceCents || 0,
      isCopyMode: !!isCopyMode,
    };
    var mounts = document.querySelectorAll('[data-cart-credit-precheckout-mount]');
    var show = !!isCopyMode && balanceCents > 0;
    var text = '';
    if (show) {
      text = creditCopiedThisSession()
        ? CREDIT_PRECHECKOUT_COPIED
        : 'You have ' + formatCad(balanceCents) + CREDIT_PRECHECKOUT_UNCOPIED;
    }
    for (var i = 0; i < mounts.length; i++) {
      mounts[i].textContent = text;
      mounts[i].hidden = !show;
    }
  }

  /** Re-render the line from the last known state. Called after a successful
   *  copy so the message flips in place. */
  function refreshCreditPreCheckout() {
    renderCreditPreCheckout(
      creditPreCheckoutState.balanceCents,
      creditPreCheckoutState.isCopyMode
    );
  }

  // Fetch /cart.js + repopulate the drawer credit notice from cachedMe.
  // Bails silently if cachedMe is null (notice stays hidden) or the
  // placeholder isn't in the DOM (empty cart / logged-out customer).
  //
  // Phase 5-γ Commit 4: accepts an optional pre-fetched cart so callers
  // that already have one (initCartLoyalty's single-fetch path) can avoid
  // a duplicate /cart.js round-trip.
  function syncDrawerCreditNotice(cart) {
    if (cachedMe === null) return Promise.resolve();
    var notice = document.querySelector('[data-cart-credit-notice]');
    if (!notice) return Promise.resolve();
    if (cart) {
      renderDrawerCreditNotice(cachedMe, cart);
      return Promise.resolve();
    }
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (freshCart) { if (freshCart) renderDrawerCreditNotice(cachedMe, freshCart); })
      .catch(function () { /* swallow — notice stays hidden */ });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartLoyalty);
  } else {
    initCartLoyalty();
  }

  // Re-compute earn preview when the cart changes (Tier 2+ only; Tier
  // 1 has nothing to recompute, and the logged-out / error states are
  // unaffected). Cached `me` is reused — only cart contents changed,
  // not the customer's tier. The refreshCartPage section swap replaces
  // [data-cart-loyalty] in the DOM, so we need to find the FRESH card
  // each event tick. State attribute survives the section render via
  // the JS innerHTML write only if refreshCartPage rendered the card
  // server-side too — but the server only renders "loading" / "logged
  // -out", so post-refresh the card is back to "loading" and we
  // re-render. Side-effect: a /cart.js fetch per cart change for
  // Tier 2+ customers. Acceptable.
  document.addEventListener('circadia:cart-changed', function () {
    var freshCard = document.querySelector('[data-cart-loyalty]');
    if (!freshCard) return;
    var state = freshCard.getAttribute('data-loyalty-state');
    if (state === 'logged-out' || state === 'error') return;
    if (!cachedMe) {
      // /me fetch hasn't completed yet (or failed earlier); the
      // initCartLoyalty path will populate when ready.
      return;
    }
    loyaltyRender(freshCard, cachedMe);
  });

  // Phase 5-γ — drawer credit notice cart-changed listener. Independent of
  // the loyalty card listener above because the drawer renders on every
  // page and the loyalty card only on /cart. Both listeners share cachedMe.
  document.addEventListener('circadia:cart-changed', function () {
    syncDrawerCreditNotice();
  });

  // === Inventory shortfall notice ===
  // When Shopify's /cart/add.js can only partially fulfill a bundle add
  // (insufficient inventory), surface a flavor-specific notice in the
  // cart drawer. Shopify returns 422 + description for partial-stock
  // adds but partial fulfillment still happens server-side — the
  // description is a single human-readable string with no per-variant
  // breakdown. We detect shortfalls by snapshotting /cart.js before +
  // after the add and computing the per-variant delta.
  //
  // Persistence model (anchor-quantity tracking):
  //   Each shortfall stores anchorQty = the cart quantity for that
  //   variant immediately after the failed add. The notice survives as
  //   long as the current cart quantity for that variant equals the
  //   anchor. Customer dismisses by:
  //     - removing the variant entirely (variant absent → dismissed)
  //     - changing the variant's quantity (qty != anchor → dismissed)
  //     - clearing the cart (all variants absent → all dismissed)
  //   Per-shortfall dismissal works for multi-shortfall notices: A and B
  //   can co-exist; acknowledging A leaves B's part of the notice intact.
  //
  // Lifecycle:
  //   1. Bundle-builder snapshotCart()s pre + post, computes shortfalls
  //      with anchorQty = post.snap[variantId]
  //   2. activeShortfalls assigned, CustomEvent dispatched
  //   3. renderShortfallNotice writes to [data-cart-shortfall-notice]
  //   4. refreshDrawer dispatches cart-changed → handler fetches /cart.js,
  //      filters survivors, re-renders. Survivors are anchored at qty
  //      they were just set to, so they survive the refresh that
  //      followed the add.
  //   5. Each subsequent cart-changed re-fetches /cart.js, re-filters,
  //      re-renders. Dropped survivors are gone; the notice shrinks or
  //      disappears as the customer mutates the cart.
  var activeShortfalls = [];

  function snapshotCart() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('cart.js HTTP ' + r.status);
        return r.json();
      })
      .then(function (cart) {
        var snap = {};
        (cart.items || []).forEach(function (it) {
          snap[it.variant_id] = it.quantity;
        });
        return { snap: snap, items: cart.items || [] };
      })
      .catch(function () { return null; });
  }

  function renderShortfallNotice() {
    var el = document.querySelector('[data-cart-shortfall-notice]');
    if (!el) return;
    while (el.firstChild) el.removeChild(el.firstChild);
    if (activeShortfalls.length === 0) {
      el.hidden = true;
      return;
    }
    if (activeShortfalls.length === 1) {
      var one = activeShortfalls[0];
      var line = one.actual === 0
        ? 'Out of stock: ' + one.flavorName + " couldn't be added (you requested " + one.requested + ' 4-packs).'
        : 'Limited stock: only ' + one.actual + ' of ' + one.requested + ' 4-packs added for ' + one.flavorName + '.';
      el.textContent = line;
    } else {
      var header = document.createElement('div');
      header.textContent = 'Limited stock on some items:';
      el.appendChild(header);
      var ul = document.createElement('ul');
      activeShortfalls.forEach(function (sf) {
        var li = document.createElement('li');
        var detail = sf.actual === 0
          ? 'out of stock'
          : sf.actual + ' of ' + sf.requested + ' 4-packs added';
        li.textContent = sf.flavorName + ': ' + detail;
        ul.appendChild(li);
      });
      el.appendChild(ul);
    }
    el.hidden = false;
  }

  document.addEventListener('circadia:inventory-shortfall', renderShortfallNotice);
  document.addEventListener('circadia:cart-changed', function () {
    // No active shortfalls → nothing to filter, nothing to render. The
    // re-render still happens (renderShortfallNotice no-ops when empty)
    // so a stale post-refresh DOM gets cleared if it ever survived.
    if (activeShortfalls.length === 0) {
      renderShortfallNotice();
      return;
    }
    // Filter survivors against the current cart. /cart.js is a small
    // round-trip; case-aggregation.js also fetches it on this same
    // event, so two parallel requests land — acceptable cost, single-
    // shot cache coalescing is a follow-up if it ever becomes hot.
    snapshotCart().then(function (current) {
      if (current === null) {
        // /cart.js failed — can't reliably filter. Leave shortfalls as
        // they are (don't false-dismiss); just re-render to repopulate
        // the post-refresh DOM if needed.
        renderShortfallNotice();
        return;
      }
      activeShortfalls = activeShortfalls.filter(function (sf) {
        var curQty = current.snap[sf.variantId];
        // Variant absent → dismissed (customer removed it).
        if (curQty === undefined) return false;
        // Quantity changed from the anchor → dismissed (customer
        // adjusted, i.e. acknowledged).
        if (curQty !== sf.anchorQty) return false;
        // Same variant, same quantity → still in the unacknowledged
        // shortfall state; keep showing.
        return true;
      });
      renderShortfallNotice();
    });
  });

  document.addEventListener('click', function (e) {
    var target = e.target.closest('[data-cart-open]');
    if (target) { e.preventDefault(); openCart(); return; }

    var closer = e.target.closest('[data-cart-close]');
    if (closer || e.target.matches('[data-cart-overlay]')) {
      // Skip preventDefault when the closer is an <a> with an href so
      // the native navigation proceeds (e.g. the drawer's "View full
      // cart →" link must navigate to /cart while ALSO closing the
      // drawer). data-cart-close on a <button> still preventDefaults
      // (no implicit form submit). Overlay clicks have no native
      // default to preserve, so preventDefault is harmless.
      var isNavLink = closer && closer.tagName === 'A' && closer.getAttribute('href');
      if (!isNavLink) e.preventDefault();
      // Move focus off the closing element BEFORE the drawer flips
      // aria-hidden=true, satisfying the "focus must not be hidden
      // from assistive tech" constraint Chromium flags. blur() drops
      // focus to <body>. Without this, AT users see a warning + the
      // drawer's aria-hidden state is technically invalid for the
      // moment between close and navigate.
      if (closer && typeof closer.blur === 'function') closer.blur();
      closeCart();
      return;
    }

    var minus = e.target.closest('[data-cart-qty-minus]');
    if (minus) {
      e.preventDefault();
      var row = minus.closest('[data-cart-item]');
      var current = parseInt(row.querySelector('.bundle-stepper-val').textContent, 10) || 0;
      changeLine(minus.dataset.cartKey, Math.max(0, current - 1), row);
      return;
    }

    var plus = e.target.closest('[data-cart-qty-plus]');
    if (plus) {
      e.preventDefault();
      var rowP = plus.closest('[data-cart-item]');
      var currentP = parseInt(rowP.querySelector('.bundle-stepper-val').textContent, 10) || 0;
      changeLine(plus.dataset.cartKey, currentP + 1, rowP);
      return;
    }

    var remove = e.target.closest('[data-cart-remove]');
    if (remove) {
      e.preventDefault();
      changeLine(remove.dataset.cartKey, 0, remove.closest('[data-cart-item]'));
      return;
    }

    var clearAll = e.target.closest('[data-cart-clear-all]');
    if (clearAll) {
      e.preventDefault();
      // confirm() blocks clearing a $300+ cart accidentally. Cheap
      // friction for an irreversible destructive action.
      if (!window.confirm('Clear all items from your cart?')) return;
      fetch('/cart/clear.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        credentials: 'same-origin',
      }).then(function () { return refreshCart(); });
      return;
    }

    // Promo code apply (cart page only — drawer has no input).
    // Reads sibling [data-cart-promo-code] input, POSTs to /cart/update.js
    // with {discount: code}, then verifies the code actually applied by
    // scanning cart_level_discount_applications in the response. Shopify
    // returns 200 even for non-existent / non-applicable codes, so the
    // application array is the only reliable signal of success.
    //
    // Stacking with the case-aggregation code is governed by Shopify
    // discount-combinability settings (configured per Eric). If the
    // user's code is non-combinable with the active case-agg code,
    // Shopify drops one of them — which one depends on the per-discount
    // combinesWith config. We don't reason about that here; we just
    // surface success/failure based on whether the entered code appears
    // in the post-update applications array.
    var promoApply = e.target.closest('[data-cart-promo-apply]');
    if (promoApply) {
      e.preventDefault();
      var promoInput = document.querySelector('[data-cart-promo-code]');
      var promoErr   = document.querySelector('[data-cart-promo-error]');
      if (promoErr) { promoErr.textContent = ''; promoErr.hidden = true; }
      var promoCode = promoInput ? (promoInput.value || '').trim() : '';
      if (!promoCode) return; // Empty input — no-op, no error.
      promoApply.disabled = true;
      fetch((window.routes && window.routes.cart_update_url ? window.routes.cart_update_url : '/cart/update') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ discount: promoCode }),
      }).then(function (r) {
        if (!r.ok) throw new Error('cart/update.js HTTP ' + r.status);
        return r.json();
      }).then(function (cart) {
        // Authoritative "is the code applied?" signal is cart.discount_codes
        // (Shopify's per-cart applied codes array, each carrying a `code`
        // field + an `applicable` boolean). cart_level_discount_applications
        // only carries `title` for code discounts — and even that wasn't
        // matching reliably in post-Phase-3 testing (see commit 8d9b715
        // diagnostic logs). Case-insensitive compare because Shopify
        // normalizes codes at apply time.
        var codes = (cart && cart.discount_codes) || [];
        var entered = promoCode.toUpperCase();
        var matched = codes.some(function (d) {
          return d && d.applicable && d.code && d.code.toUpperCase() === entered;
        });
        if (!matched) throw new Error('code-not-applicable');
        if (promoInput) promoInput.value = '';
        return refreshCart();
      }).catch(function (err) {
        if (window.console && window.console.warn) {
          console.warn('[cart-promo] apply failed:', err && err.message ? err.message : err);
        }
        if (promoErr) { promoErr.textContent = 'Code not valid'; promoErr.hidden = false; }
      }).then(function () {
        promoApply.disabled = false;
      });
      return;
    }

    // Phase 5-γ Commit 4 — credit Apply button (MODE A, cart-page).
    // Apply-as-total semantics: input value IS the desired total credit
    // applied to the cart. Validate against the data-cart-credit-
    // amount-max ceiling (= min(balance, cart-gross)). No-op skip when
    // desiredTotal === appliedCredit to avoid round-trips on accidental
    // double-clicks.
    var creditApply = e.target.closest('[data-cart-credit-apply]');
    if (creditApply) {
      e.preventDefault();
      if (creditApply.disabled) return;
      var creditRow = creditApply.closest('[data-cart-credit-row]');
      var input = creditRow && creditRow.querySelector('[data-cart-credit-input]');
      if (!input) return;
      var dollars = parseFloat(input.value);
      if (!Number.isFinite(dollars) || dollars <= 0) {
        showCreditError('cart', 'Enter an amount greater than $0.00.');
        return;
      }
      var desiredTotalCents = Math.round(dollars * 100);
      var maxCents = parseInt(input.getAttribute('data-cart-credit-amount-max') || '0', 10);
      if (desiredTotalCents > maxCents) desiredTotalCents = maxCents;
      // No-op check — skip the API call if the customer hit Apply with
      // the already-applied amount (e.g., accidental double-click on a
      // fully-applied cart, or the customer cleared the input then
      // re-typed the same number).
      var appliedCreditCents = parseInt(creditRow.getAttribute('data-cart-credit-applied-cents') || '0', 10);
      if (desiredTotalCents === appliedCreditCents) return;
      creditApply.disabled = true;
      applyCreditFromCart(desiredTotalCents, 'cart').then(function () {
        // Re-enable on failure; success path triggers a re-render that
        // replaces the button entirely.
        creditApply.disabled = false;
      });
      return;
    }

    // Phase 5-γ Commit 4 — credit Copy button (MODE B, cart-page OR
    // drawer). Mints + writes the code to clipboard; reservation
    // persists for paste at Shopify Checkout. Does NOT call
    // /cart/update.js — combinesWith=true at checkout lets the customer
    // stack CC- with the CASE- already on cart.
    //
    // Cart-page MODE B: input is present in the row; read input value.
    // Drawer MODE B: no input (compact discovery surface); read
    // data-cart-credit-amount-max directly from the button.
    var creditCopy = e.target.closest('[data-cart-credit-copy]');
    if (creditCopy) {
      e.preventDefault();
      if (creditCopy.disabled) return;
      var copyRow = creditCopy.closest('[data-cart-credit-row], [data-cart-credit-notice]');
      var copyInput = copyRow && copyRow.querySelector('[data-cart-credit-input]');
      var copyScope = creditCopy.closest('[data-cart-credit-notice]') ? 'drawer' : 'cart';
      var copyCents;
      if (copyInput) {
        // Cart-page MODE B — read + validate the input value.
        var copyDollars = parseFloat(copyInput.value);
        if (!Number.isFinite(copyDollars) || copyDollars <= 0) {
          showCreditError(copyScope, 'Enter an amount greater than $0.00.');
          return;
        }
        copyCents = Math.round(copyDollars * 100);
        var copyMaxCents = parseInt(copyInput.getAttribute('data-cart-credit-amount-max') || '0', 10);
        if (copyCents > copyMaxCents) copyCents = copyMaxCents;
        // No no-op skip for Copy — clipboard write is the actual user
        // action; the customer may want to re-copy the same amount.
      } else {
        // Drawer MODE B — use the button's data attr.
        copyCents = parseInt(creditCopy.getAttribute('data-cart-credit-amount-max') || '0', 10);
      }
      if (copyCents <= 0) return;
      copyCreditCodeToClipboard(copyCents, copyScope, creditCopy);
      return;
    }

    // Remove applied discount (× button next to a discount line).
    // Empty-string discount trick: /cart/update.js {discount: ''}
    // clears the entire applied set. Shopify doesn't expose per-code
    // removal in the storefront API, so the button removes ALL applied
    // codes — fine pre-launch where a single code at a time is the
    // norm. Case-aggregation's reconcile re-applies its own code on
    // the next circadia:cart-changed if the cart still qualifies,
    // which means clicking Remove on a case-agg discount briefly
    // disappears it before it auto-reapplies.
    //
    // Phase 5-γ Commit 4 — special-case CC- codes: before the empty-
    // string clear, fetch /cart.js, detect any CC- code, and call
    // DELETE /cart-credit to release the server-side reservation. The
    // DELETE is fire-and-forget (errors swallowed via releaseCartCredit)
    // so a release failure doesn't block the cart-side clear; the 72h
    // sweep collects orphaned rows as belt-and-suspenders.
    var discountRemove = e.target.closest('[data-cart-discount-remove]');
    if (discountRemove) {
      e.preventDefault();
      discountRemove.disabled = true;
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; })
        .then(function (cart) {
          // If CC- is on the cart, release the reservation first. The
          // existing empty-string clear still fires regardless.
          if (cart && detectCreditCode(cart)) {
            // The reservation is being released, so the copied code is dead.
            // Clear the latch here as well as via the render-time transition:
            // this path can run with no credit row mounted to observe it, and
            // leaving it set would keep telling the customer to paste a code
            // that no longer exists.
            clearCreditCopiedThisSession();
            return releaseCartCredit();
          }
        })
        .then(function () {
          return fetch((window.routes && window.routes.cart_update_url ? window.routes.cart_update_url : '/cart/update') + '.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify({ discount: '' }),
          });
        })
        .then(function (r) { return r.json(); })
        .then(function () { return refreshCart(); })
        .catch(function (err) {
          if (window.console && window.console.warn) {
            console.warn('[cart-discount-remove] clear failed:', err && err.message ? err.message : err);
          }
          discountRemove.disabled = false;
        });
      return;
    }
  });

  // === Universal Add to Cart interceptor (Ajax) ===
  // Catches submission of ANY form whose action contains '/cart/add' —
  // covers Circadia's #pdp-add-form (main-product.liquid), Dawn's
  // <product-form> instances in buy-buttons.liquid (collection grids,
  // featured products), and any future surface that POSTs to the
  // standard cart-add endpoint.
  //
  // Why action-based instead of id-based: the d82e0c6 commit used an
  // id selector and didn't fire on the live theme — root cause not
  // diagnosable from code alone (most likely Shopify-rendered id quirk
  // or section-prefix). Action-based matching sidesteps every possible
  // id quirk AND gives universal surface coverage in one selector.
  //
  // Conflict with Dawn's product-form.js: that script defines a
  // <product-form> custom element whose constructor attaches a
  // bubble-phase submit handler at the form element. With our
  // capture-phase listener at document, we fire first; stopImmediate-
  // Propagation halts the event so Dawn's handler never runs. No need
  // to remove Dawn's script (it stays defined; just never receives the
  // event for cart-add forms).
  //
  // FormData captures everything Shopify needs: id, quantity,
  // properties[*], selling_plan, hidden authenticity_token, and any
  // section-rendering hints from Dawn forms. Shopify /cart/add.js
  // accepts FormData natively.
  //
  // Failure modes:
  //   - 5xx / network error → throw → re-enable submit button, user
  //     retries. No fallback to native submit (would re-trigger the
  //     /cart navigation we're fixing).
  //   - 422 (insufficient inventory) → still proceeds to drawer open;
  //     the existing shortfall-notice flow (bundle-builder) doesn't
  //     run here because we don't pre/post-snapshot for PDP/collection
  //     adds, but Shopify still adds max-available so the drawer reflects
  //     the partial add. Adding shortfall detection to this path is a
  //     follow-up if needed.
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    var action = form.getAttribute('action') || '';
    if (!/\/cart\/add/.test(action)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var submitBtn = form.querySelector('button[type="submit"], [type="submit"]');
    if (submitBtn) submitBtn.disabled = true;
    var formData = new FormData(form);
    fetch(window.routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: formData,
    }).then(function (r) {
      if (r.status >= 500) {
        return r.text().then(function (t) {
          throw new Error('cart/add.js HTTP ' + r.status + ': ' + t);
        });
      }
      return r.json().catch(function () { return {}; });
    }).then(function () {
      document.body.classList.add('cart-open');
      var d = $('[data-cart-drawer]');
      var o = $('[data-cart-overlay]');
      if (d) d.classList.add('open');
      if (o) o.classList.add('open');
      // refreshCart updates both drawer and cart-page (when on /cart);
      // each dispatches 'circadia:cart-changed' on completion, which
      // case-aggregation.js and the inventory-shortfall handler both
      // listen to. The drawer auto-open above stays — refreshCart
      // doesn't toggle open/close, only re-renders.
      //
      // RETURNED (it was previously called and dropped) so the re-enable
      // below waits for the render to finish. A fast double-click must not
      // fire a second add while the drawer is still rendering.
      //
      // Its own failure is caught HERE rather than falling through to the
      // outer catch: the add SUCCEEDED, the item is in the cart, and only
      // the re-render failed. Letting it reach the outer handler would log
      // it as '[cart-add] Ajax failed', which would be untrue and would
      // send anyone debugging it to the wrong place.
      return refreshCart().catch(function (renderErr) {
        if (window.console && window.console.warn) {
          console.warn(
            '[cart-add] add succeeded but refreshCart failed:',
            renderErr && renderErr.message ? renderErr.message : renderErr
          );
        }
      });
    }).then(function () {
      // ⚠ SEPARATE LINK IN THE CHAIN, DELIBERATELY, and this is the whole
      // fix. The button was disabled on every submit and re-enabled ONLY in
      // .catch(), so a SUCCESSFUL add locked it for the rest of the page
      // session. Nothing rescued it: refreshCart re-renders the drawer and
      // cart page but never the PDP form, and selecting a subscription
      // cadence writes to a hidden input rather than re-rendering. The
      // customer had to reload to add anything else.
      //
      // Why its own .then() rather than a line at the end of the handler
      // above: an early `return` inside that handler resolves it, and the
      // NEXT link still runs. So no future refactor that adds an early exit
      // can skip the re-enable. That is the guarantee .finally() would give,
      // without introducing the first ES2018 .finally() into a file that is
      // deliberately ES5-ish for browser reach.
      if (submitBtn) submitBtn.disabled = false;
    }).catch(function (err) {
      if (window.console && window.console.warn) {
        console.warn('[cart-add] Ajax failed:', err && err.message ? err.message : err);
      }
      // Failure path re-enable, unchanged: the customer retries.
      if (submitBtn) submitBtn.disabled = false;
    });
  }, { capture: true });

  // === Checkout-guard toast ===
  // Floating fixed-position notice shown for ~4s when the checkout guard
  // silently clears a case discount on click (Phase 3B-1 Part 4b-3,
  // client-side pivot — see docs/01_ARCHITECTURE/EDGE_CASES.md EC-035).
  //
  // DESIGN CHOICE — floating toast, NOT reusing the inventory-shortfall
  // inline notice (commit 6e372dc). Two reasons:
  //   1. The shortfall notice fires while the customer is looking at the
  //      drawer (predictor shimmer → inline notice in drawer body). The
  //      checkout guard fires as the customer is LEAVING the drawer (they
  //      just clicked Checkout). A drawer-internal notice gets less
  //      attention in the 400ms window before form.submit() fires.
  //   2. The toast survives any drawer-collapse animation Shopify might
  //      trigger during the click→submit transition; an inline element
  //      inside the drawer DOM would be at risk of being mid-rendered or
  //      collapsed when the customer's focus shifts.
  //
  // Toast copy is short, declarative, em-dash-styled to match Circadia's
  // brand typography (e.g. "Drift — Blackberry Plum Chamomile"). No
  // exclamation marks, no "oops" energy.
  function showCheckoutGuardToast(message) {
    var existing = document.querySelector('[data-checkout-guard-toast]');
    if (existing && existing.parentNode) existing.parentNode.removeChild(existing);
    var el = document.createElement('div');
    el.className = 'checkout-guard-toast';
    el.setAttribute('data-checkout-guard-toast', '');
    el.setAttribute('role', 'status');
    el.textContent = message;
    document.body.appendChild(el);
    // Trigger slide-in on the next frame so the initial state is applied.
    requestAnimationFrame(function () { el.classList.add('is-visible'); });
    setTimeout(function () {
      if (el && el.parentNode) {
        el.classList.remove('is-visible');
        setTimeout(function () {
          if (el && el.parentNode) el.parentNode.removeChild(el);
        }, 250);
      }
    }, 4000);
  }

  // === Checkout-button capture-phase interceptor ===
  // Phase 3B-1 Part 4b-3 client-side pivot (EC-035 in EDGE_CASES.md).
  //
  // WHY CAPTURE PHASE: matches the universal /cart/add interceptor above
  // (commit c8781fd). Capture-mode at document level fires before any
  // bubble-phase listeners on the button or form; combined with
  // stopImmediatePropagation, we halt the native click chain cleanly and
  // run the async guard before submitting programmatically.
  //
  // WHY RE-ENTRY FLAG: after the guard resolves, we trigger the actual
  // form submission. Our preferred path is form.submit() (bypasses click
  // listeners entirely), but the cart-drawer form's action is
  // {{ routes.cart_url }} = /cart, not /checkout — Shopify routes to
  // checkout via the submit button's name="checkout" attribute, which a
  // bare form.submit() won't honor. We fall back to button.click()
  // synthesizing a native click; the re-entry flag prevents our own
  // interceptor from intercepting the synthesized click.
  //
  // WHY FAIL-OPEN: the guard is a soft safety net (the deployed Shopify
  // function would have been the hard one, blocked on Plus gating per
  // EC-035). If the guard throws, times out, or the case-aggregation
  // module never loaded, the customer should not be blocked from
  // checking out. Post-hoc audit via the fa6d056 mint metafield catches
  // any actual mismatch.
  var checkoutGuardSubmitting = false;
  var GUARD_HARD_TIMEOUT_MS = 2500;
  var POST_CLEAR_TOAST_DELAY_MS = 400;
  var CHECKOUT_GUARD_TOAST_MESSAGE =
    'Your cart shifted. Case pricing no longer applies; continuing at standard rate.';
  // Phase 5B Commit 5B-4 — sample-claim guard toast. Shown when the
  // sample-claim cart guard (window.Circadia.sampleClaim.guardCheckout)
  // strips a stale SAMPLE-{16hex} discount because the cart no longer
  // matches the expected 1-RISE-1-DRIFT shape. Brand-typography style
  // (em-dash, no exclamation) matches the case-aggregation toast.
  var SAMPLE_CLAIM_GUARD_TOAST_MESSAGE =
    'Your sample selection changed, so the discount was removed. ' +
    'Re-claim your sample to start over, or continue at standard price.';

  // Defensive guard runners — each returns a no-op proceed:true result
  // when its module didn't load, so the chain never blocks on a missing
  // module. Both guards' contracts are { proceed:true always,
  // removedDiscount, reason } — proceed:false never fires.
  function runCaseAggregationGuard() {
    if (!window.Circadia ||
        !window.Circadia.caseAggregation ||
        typeof window.Circadia.caseAggregation.guardCheckout !== 'function') {
      if (window.console && window.console.warn) {
        console.warn('[checkout-guard] caseAggregation guard unavailable; skipping');
      }
      return Promise.resolve({ proceed: true, removedDiscount: false, reason: 'guard-unavailable' });
    }
    return window.Circadia.caseAggregation.guardCheckout();
  }
  function runSampleClaimGuard() {
    if (!window.Circadia ||
        !window.Circadia.sampleClaim ||
        typeof window.Circadia.sampleClaim.guardCheckout !== 'function') {
      if (window.console && window.console.warn) {
        console.warn('[checkout-guard] sampleClaim guard unavailable; skipping');
      }
      return Promise.resolve({ proceed: true, removedDiscount: false, reason: 'guard-unavailable' });
    }
    return window.Circadia.sampleClaim.guardCheckout();
  }

  /**
   * Credit reminder guard. Toast only.
   *
   * ⚠ DELIBERATELY DOES NOT COPY OR MINT. An earlier draft auto-copied the
   * code on the Checkout click. Two reasons it was dropped: a clipboard write
   * inside an async guard may fall outside the browser's user-gesture window
   * and fail silently, and, more importantly, MINTING SPENDS A CUSTOMER'S
   * CREDIT BECAUSE THEY CLICKED CHECKOUT. A customer saving credit for a
   * bigger order would have it spent by a button they pressed for a different
   * purpose. The system must not decide that for them.
   *
   * Fires only in MODE B, with spendable credit, when they have not copied
   * this session. Silent otherwise, including when they already copied.
   *
   * Same contract as the other two runners: proceed ALWAYS true, never blocks.
   * Fully wrapped in try/catch and always resolves, so it cannot break
   * checkout even if the state read throws.
   */
  function runCreditGuard() {
    try {
      if (!creditPreCheckoutState.isCopyMode) {
        return Promise.resolve({ proceed: true, notified: false, reason: 'not-copy-mode' });
      }
      if (!(creditPreCheckoutState.balanceCents > 0)) {
        return Promise.resolve({ proceed: true, notified: false, reason: 'no-credit' });
      }
      if (creditCopiedThisSession()) {
        return Promise.resolve({ proceed: true, notified: false, reason: 'already-copied' });
      }
      return Promise.resolve({
        proceed: true,
        notified: true,
        reason: 'uncopied-credit',
        message:
          'You have ' + formatCad(creditPreCheckoutState.balanceCents) +
          ' credit. Add it in the discount box at checkout.',
      });
    } catch (err) {
      if (window.console && window.console.warn) {
        console.warn('[checkout-guard] credit guard threw; proceeding:', err);
      }
      return Promise.resolve({ proceed: true, notified: false, reason: 'guard-threw' });
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cart-drawer] button[name="checkout"], [data-cart-page] button[name="checkout"]');
    if (!btn) return;

    // Re-entry: this click was synthesized by us after the guard ran.
    // Reset the flag and let the click proceed natively to Shopify's
    // standard form submission (which respects the button's name attribute
    // and routes to checkout).
    if (checkoutGuardSubmitting) {
      checkoutGuardSubmitting = false;
      return;
    }

    e.preventDefault();
    e.stopImmediatePropagation();

    var form = btn.closest('form');
    if (!form) {
      // Form-ownership attribute fallback. The cart-page Checkout button
      // lives in main-cart-footer.liquid OUTSIDE the cart form (which
      // lives in main-cart-items.liquid) and ties itself via <button
      // form="cart">. closest('form') doesn't traverse this association,
      // so without this fallback the guard aborts after preventDefault
      // fired → dead click. The drawer button is inside its <form>, so
      // closest('form') finds it without needing this branch.
      var formId = btn.getAttribute('form');
      if (formId) form = document.getElementById(formId);
    }
    if (!form) {
      // Truly no form — defensive path, not reachable in current surfaces.
      // preventDefault has already fired so the customer would otherwise
      // see a dead button; we don't have a sane recovery here, so log
      // and return (the page-reload-and-retry path still works).
      if (window.console && window.console.warn) {
        console.warn('[checkout-guard] no form found via closest or [form] attribute; aborting guard');
      }
      return;
    }

    btn.disabled = true;
    btn.classList.add('is-loading');

    // Hard timeout safety: if guardCheckout() never resolves (catastrophic
    // module failure, runaway promise, etc.), force-submit the form after
    // 2500ms so the customer is never trapped.
    var hardTimeoutId = setTimeout(function () {
      if (window.console && window.console.warn) {
        console.warn('[checkout-guard] hard timeout exceeded; force-submitting');
      }
      submitForm(form, btn);
    }, GUARD_HARD_TIMEOUT_MS);

    function restoreButton() {
      btn.disabled = false;
      btn.classList.remove('is-loading');
    }

    function submitForm(theForm, theBtn) {
      clearTimeout(hardTimeoutId);
      checkoutGuardSubmitting = true;
      // form.submit() would skip the submit button's name="checkout" param,
      // so Shopify wouldn't route to checkout. Synthesize a button click
      // instead — our re-entry flag short-circuits this interceptor on the
      // second pass.
      try {
        theBtn.click();
      } catch (err) {
        if (window.console && window.console.warn) {
          console.warn('[checkout-guard] synthesized click failed:',
            err && err.message ? err.message : err);
        }
        // Defensive fallback: native form submission (won't route to
        // checkout, but at least the customer isn't trapped on a disabled
        // button).
        try { theForm.submit(); } catch (_) { /* nothing else to try */ }
      }
    }

    // Chain BOTH guards in sequence: case-aggregation first (existing
    // precedent + the most likely to clear a stale state), then
    // sample-claim (the new 5B-4 guard for the launch-offer cart shape).
    // Each runner has its own missing-module fallback so the chain never
    // blocks on a load failure — worst case, both are unavailable and we
    // proceed without guard (same posture as the original case-agg
    // standalone path). Hard timeout still wraps the whole chain.
    runCaseAggregationGuard()
      .then(function (caseResult) {
        return runSampleClaimGuard().then(function (sampleResult) {
          // Credit guard LAST: it only ever adds a toast, so it must not delay
          // the two guards that can actually change the cart.
          return runCreditGuard().then(function (creditResult) {
            return {
              caseResult: caseResult,
              sampleResult: sampleResult,
              creditResult: creditResult,
            };
          });
        });
      })
      .then(function (results) {
        clearTimeout(hardTimeoutId);
        var caseResult = results.caseResult || {};
        var sampleResult = results.sampleResult || {};
        var creditResult = results.creditResult || {};
        // Contract: proceed is ALWAYS true on both. Defensively check —
        // if either explicitly returns proceed:false (future-extension
        // semantics), respect it.
        if (caseResult.proceed === false || sampleResult.proceed === false) {
          restoreButton();
          return;
        }
        var caseRemoved = caseResult.removedDiscount === true;
        var sampleRemoved = sampleResult.removedDiscount === true;
        if (caseRemoved || sampleRemoved) {
          // Show whichever toast applies. If both removed (unlikely —
          // sample is closed-economy non-stackable so case-agg shouldn't
          // also be applied), show the case-agg toast since it ran first.
          if (caseRemoved) {
            showCheckoutGuardToast(CHECKOUT_GUARD_TOAST_MESSAGE);
          } else {
            showCheckoutGuardToast(SAMPLE_CLAIM_GUARD_TOAST_MESSAGE);
          }
          setTimeout(function () {
            restoreButton();
            submitForm(form, btn);
          }, POST_CLEAR_TOAST_DELAY_MS);
        } else if (creditResult.notified === true && creditResult.message) {
          // Nothing was removed, but the customer is about to leave with
          // uncopied credit. Reuse the same toast + delay as the removal
          // paths so the message is actually seen before the page changes.
          showCheckoutGuardToast(creditResult.message);
          setTimeout(function () {
            restoreButton();
            submitForm(form, btn);
          }, POST_CLEAR_TOAST_DELAY_MS);
        } else {
          restoreButton();
          submitForm(form, btn);
        }
      })
      .catch(function (err) {
        // Fail-open per D3 spec — orders/paid (5B-6) is the server-side
        // backstop for sample-claim, and the case-aggregation mint
        // metafield (fa6d056) is the audit trail for case-agg.
        if (window.console && window.console.warn) {
          console.warn('[checkout-guard] guard chain threw, failing open:',
            err && err.message ? err.message : err);
        }
        clearTimeout(hardTimeoutId);
        restoreButton();
        submitForm(form, btn);
      });
  }, { capture: true });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && document.body.classList.contains('cart-open')) {
      closeCart();
      return;
    }
    // Enter on the cart-page promo input → synthesize a click on the
    // Apply button. The input is outside the cart form (the form lives
    // in main-cart-items, the input lives in main-cart-footer), so
    // pressing Enter would otherwise no-op. Click-synthesis keeps the
    // apply logic in one branch (the document click handler).
    if (e.key === 'Enter' && e.target && typeof e.target.matches === 'function' && e.target.matches('[data-cart-promo-code]')) {
      e.preventDefault();
      var applyBtn = document.querySelector('[data-cart-promo-apply]');
      if (applyBtn) applyBtn.click();
    }
  });

  // PDP accordion: swap + and − on the marker when <details> toggles.
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (!(d instanceof HTMLDetailsElement)) return;
    var mark = d.querySelector('[data-pdp-acc-mark]');
    if (mark) mark.textContent = d.open ? '−' : '+';
  }, true);

  // PDP buy-box: One-time / Subscribe cadence toggle.
  //
  // Selecting a subscribe pill writes the plan's GID-numeric id into the
  // form's [data-pdp-selling-plan] hidden input (name="selling_plan");
  // selecting one-time clears it. The universal /cart/add interceptor
  // above forwards the FormData verbatim, so /cart/add.js receives the
  // plan id and Shopify attaches a SellingPlanAllocation to the line.
  //
  // The form's PDP section sibling (.pdp-info) is the common ancestor of
  // the options group and the form — the click handler walks up to it
  // to bridge the two.
  function recomputePdpTotal(form) {
    if (!form) return;
    var info = form.closest('.pdp-info');
    var active = info && info.querySelector('[data-pdp-option].active');
    var unitCents = active ? parseInt(active.dataset.unitCents, 10) : NaN;
    if (!isFinite(unitCents)) return;
    var qtyInput = form.querySelector('[data-pdp-qty-input]');
    var qty = parseInt(qtyInput && qtyInput.value, 10) || 1;
    var totalEl = form.querySelector('[data-pdp-total]');
    if (totalEl) totalEl.textContent = '$' + ((unitCents * qty) / 100).toFixed(2);
  }
  document.addEventListener('click', function (e) {
    var opt = e.target.closest('[data-pdp-option]');
    if (!opt) return;
    var group = opt.closest('[data-pdp-options]');
    if (!group) return;
    $$('[data-pdp-option]', group).forEach(function (o) { o.classList.remove('active'); });
    opt.classList.add('active');
    var radio = opt.querySelector('input[type=radio]');
    if (radio) radio.checked = true;
    var info = group.closest('.pdp-info');
    var form = info && info.querySelector('form');
    if (form) {
      var planInput = form.querySelector('[data-pdp-selling-plan]');
      if (planInput) planInput.value = opt.dataset.planId || '';
      recomputePdpTotal(form);
    }
  });

  // PDP buy-box: qty stepper + live total in the Add-to-cart button.
  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-pdp-qty]');
    if (!step) return;
    e.preventDefault();
    var form = step.closest('form');
    if (!form) return;
    var valEl = form.querySelector('[data-pdp-qty-val]');
    var hidden = form.querySelector('[data-pdp-qty-input]');
    var current = parseInt(valEl.textContent, 10) || 1;
    var next = Math.max(1, current + parseInt(step.dataset.pdpQty, 10));
    valEl.textContent = next;
    if (hidden) hidden.value = next;
    recomputePdpTotal(form);
  });

  // Playbook detail interactions live in playbook-detail.js (loaded
  // by sections/page-playbook.liquid). Day cards are JS-hydrated from
  // the API payload, so chrome.js's static binding here would attach
  // to nothing on initial load — the new file owns the lifecycle.

  // === Journal index: filter pills + search ===
  (function initJournal() {
    var root = document.querySelector('[data-journal-root]');
    if (!root) return;
    var input = root.querySelector('[data-journal-q]');
    var clearBtn = root.querySelector('[data-journal-q-clear]');
    var countEl = root.querySelector('[data-journal-count]');
    var pills = root.querySelectorAll('[data-journal-filter]');
    var cards = document.querySelectorAll('[data-journal-card]');
    var totalCount = cards.length;
    var activeKind = 'All';
    var activeQuery = '';

    function apply() {
      var visible = 0;
      cards.forEach(function (card) {
        var kind = card.getAttribute('data-journal-kind');
        var hay = card.getAttribute('data-journal-haystack') || '';
        var matchesKind = activeKind === 'All' || kind === activeKind;
        var matchesQuery = activeQuery === '' || hay.indexOf(activeQuery) !== -1;
        var show = matchesKind && matchesQuery;
        card.classList.toggle('is-hidden', !show);
        if (show) visible++;
      });
      if (countEl) {
        var pad = function (n) { return ('00' + n).slice(-2); };
        countEl.textContent = pad(visible) + ' of ' + pad(totalCount) + ' articles';
      }
    }

    pills.forEach(function (p) {
      p.addEventListener('click', function () {
        activeKind = p.getAttribute('data-journal-filter');
        pills.forEach(function (x) { x.classList.toggle('active', x === p); });
        apply();
      });
    });
    if (input) {
      input.addEventListener('input', function () {
        activeQuery = input.value.trim().toLowerCase();
        if (clearBtn) clearBtn.hidden = activeQuery === '';
        apply();
      });
    }
    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        input.value = '';
        activeQuery = '';
        clearBtn.hidden = true;
        apply();
      });
    }
  })();

  // === Article: copy-link button ===
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-copy-link]');
    if (!btn) return;
    e.preventDefault();
    var url = btn.getAttribute('data-url') || window.location.href;
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(function () {
        var orig = btn.textContent;
        btn.textContent = 'Copied';
        setTimeout(function () { btn.textContent = orig; }, 1500);
      });
    }
  });

  // === Nav dropdown (hover-with-delay) ===
  // Two previous pure-CSS attempts (initial bridge + the calc(100% - 8px)
  // / 32px geometry retune in 4a0bce8) failed in practice — the dropdown
  // closed when the mouse traversed the gap from trigger to menu, even
  // though the geometry math said the bridge fully covered the path.
  // Switched to JS-controlled visibility: mouseenter adds .is-open
  // immediately; mouseleave starts a 200ms timer that mouseenter (on the
  // dropdown root, including descendant menu via bubbling) cancels. The
  // 200ms delay is generous enough to absorb any traversal gap regardless
  // of the underlying CSS rendering quirk.
  //
  // The bridge element + bridge CSS are retained as defense-in-depth (see
  // circadia.css comment); the primary close behavior is here.
  //
  // Keyboard accessibility still works via .nav-dropdown:focus-within /
  // .nav-signin:focus-within in CSS — tabbing into the dropdown opens
  // the menu without JS involvement.
  //
  // Covers both the center nav dropdowns (.nav-dropdown — shop, about)
  // and the top-right account dropdown (.nav-signin — signed-in menu).
  // c5f0743 originally only bound .nav-dropdown; .nav-signin was added
  // afterward when the same close-immediately bug was surfaced.
  (function initNavDropdowns() {
    var CLOSE_DELAY_MS = 200;
    function setup(d) {
      var timer = null;
      d.addEventListener('mouseenter', function () {
        if (timer) { clearTimeout(timer); timer = null; }
        d.classList.add('is-open');
      });
      d.addEventListener('mouseleave', function () {
        if (timer) clearTimeout(timer);
        timer = setTimeout(function () {
          d.classList.remove('is-open');
          timer = null;
        }, CLOSE_DELAY_MS);
      });
    }
    function init() {
      $$('.nav-dropdown, .nav-signin').forEach(setup);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  // The focusable controls inside a dialog (the phone menu), in tab order.
  function dialogFocusables(drawer) {
    return Array.prototype.slice.call(drawer.querySelectorAll('a[href], button, input:not([type="hidden"]), select, textarea, [tabindex]')).filter(function (el) {
      return !el.disabled && el.getAttribute('tabindex') !== '-1' && !el.closest('[hidden]');
    });
  }

  // === Mobile nav drawer (hamburger) ===
  // ST-015 (2026-10-07): the phone menu is a MODAL DIALOG. It is rendered closed (inert, aria-hidden); opening removes inert, flags the burger expanded and moves focus in; Tab
  // wraps inside it; Escape, the close button and a link tap close it, and focus goes back to the burger (unless the visitor has already moved it). The desktop layout starts at
  // 768 px (tablets included), so growing the window to that width closes it. Pinned by app/src/theme-mobile-nav.test.ts.
  (function initMobileNav() {
    var burger = document.querySelector('[data-nav-burger]');
    var drawer = document.querySelector('[data-nav-drawer]');
    if (!burger || !drawer) return;
    var DESKTOP_MIN_WIDTH = 921; // this header shows the burger at 920px and below
    function isOpen() { return document.body.classList.contains('mobile-nav-open'); }
    function setOpen(open) {
      var wasOpen = isOpen();
      var focusWasInside = drawer.contains(document.activeElement);
      document.body.classList.toggle('mobile-nav-open', open);
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
      if (open) drawer.removeAttribute('inert'); else drawer.setAttribute('inert', '');
      if (open && !wasOpen) {
        if (typeof drawer.focus === 'function') drawer.focus({ preventScroll: true });
      } else if (!open && wasOpen && (focusWasInside || document.activeElement === document.body)) {
        burger.focus();
      }
    }
    burger.addEventListener('click', function () {
      setOpen(!isOpen());
    });
    drawer.addEventListener('click', function (e) {
      // Close after any link tap so the underlying page becomes visible,
      // OR after the explicit × close button (data-nav-close) is tapped.
      if (e.target.closest('a') || e.target.closest('[data-nav-close]')) setOpen(false);
    });
    document.addEventListener('keydown', function (e) {
      if (!isOpen()) return;
      if (e.key === 'Escape') { setOpen(false); return; }
      if (e.key !== 'Tab') return;
      var items = dialogFocusables(drawer);
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      var active = document.activeElement;
      if (e.shiftKey && (active === first || active === drawer || !drawer.contains(active))) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && (active === last || !drawer.contains(active))) {
        e.preventDefault();
        first.focus();
      }
    });
    window.addEventListener('resize', function () {
      if (window.innerWidth >= DESKTOP_MIN_WIDTH) setOpen(false);
    });
  })();

  // === Product card — per-card media tabs (Can / 4-pack / Stats / Inside) ===
  document.addEventListener('click', function (e) {
    var tab = e.target.closest('[data-pc-tab]');
    if (!tab) return;
    e.preventDefault();
    var card = tab.closest('[data-pc-card]');
    if (!card) return;
    var which = tab.getAttribute('data-pc-tab');
    card.querySelectorAll('[data-pc-tab]').forEach(function (t) {
      t.classList.toggle('active', t === tab);
    });
    card.querySelectorAll('[data-pc-view]').forEach(function (v) {
      v.hidden = v.getAttribute('data-pc-view') !== which;
    });
  });

  // === Home science teaser — RISE / DRIFT toggle ===
  // Swaps panel content, accent color, glyph, the curve path (rise = upward
  // wave, drift = downward wave), and runs a short fade so the transition
  // doesn't snap.
  (function initScienceTeaser() {
    var root = document.querySelector('[data-science-teaser]');
    if (!root) return;
    var tabs = root.querySelectorAll('[data-stack-tab]');
    var panels = root.querySelectorAll('[data-stack-panel]');
    var kicker = root.querySelector('[data-science-kicker]');
    var accent = root.querySelector('[data-science-accent]');
    var glyph = root.querySelector('[data-science-glyph]');
    var curve = root.querySelector('[data-science-curve]');
    var current = root.querySelector('[data-stack-panel="rise"]');
    var fading = false;
    var GLYPH_RISE = '<svg viewBox="0 0 48 48" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><circle cx="24" cy="24" r="8"/><line x1="24" y1="4" x2="24" y2="10"/><line x1="24" y1="38" x2="24" y2="44"/><line x1="4" y1="24" x2="10" y2="24"/><line x1="38" y1="24" x2="44" y2="24"/><line x1="10" y1="10" x2="14" y2="14"/><line x1="34" y1="34" x2="38" y2="38"/><line x1="10" y1="38" x2="14" y2="34"/><line x1="34" y1="14" x2="38" y2="10"/></svg>';
    var GLYPH_DRIFT = '<svg viewBox="0 0 48 48" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><path d="M30 8 a 18 18 0 1 0 10 32 a 14 14 0 1 1 -10 -32 Z"/></svg>';
    var PATH_RISE  = 'M0 280 Q400 140 800 200 T1600 160 L1600 400 L0 400 Z';
    var PATH_DRIFT = 'M0 200 Q400 320 800 260 T1600 300 L1600 400 L0 400 Z';

    function applyStack(which, prevPanel) {
      tabs.forEach(function (t) { t.classList.toggle('active', t.getAttribute('data-stack-tab') === which); });
      panels.forEach(function (p) { p.hidden = p.getAttribute('data-stack-panel') !== which; });
      root.classList.remove('tone-rise', 'tone-drift');
      root.classList.add('tone-' + which);
      if (accent) accent.style.color = which === 'rise' ? 'var(--rise)' : 'var(--drift)';
      if (kicker) kicker.textContent = which === 'rise' ? 'Made for your morning lift' : 'Made for your evening unwind';
      if (glyph) glyph.innerHTML = which === 'rise' ? GLYPH_RISE : GLYPH_DRIFT;
      if (curve) curve.setAttribute('d', which === 'rise' ? PATH_RISE : PATH_DRIFT);
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var which = tab.getAttribute('data-stack-tab');
        if (fading) return;
        if (current && current.getAttribute('data-stack-panel') === which) return;
        fading = true;
        // Fade out the currently visible panel
        if (current) current.classList.add('is-fading');
        setTimeout(function () {
          applyStack(which);
          current = root.querySelector('[data-stack-panel="' + which + '"]');
          // Start hidden-fade on the new panel, then remove on next frame
          if (current) current.classList.add('is-fading');
          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              if (current) current.classList.remove('is-fading');
              fading = false;
            });
          });
        }, 240);
      });
    });
  })();

  // === Ecosystem — clickable subbrand dial ===
  // Only live cells are clickable; locked cells have aria-disabled set and
  // the handler bails out. Selected cell opens its band beneath the dial;
  // every other band is hidden.
  (function initEcoDial() {
    var root = document.querySelector('[data-eco-dial]');
    if (!root) return;
    var cells = root.querySelectorAll('[data-eco-cell]');
    var bands = document.querySelectorAll('[data-eco-band]');
    cells.forEach(function (cell) {
      cell.addEventListener('click', function () {
        if (cell.getAttribute('aria-disabled') === 'true' || cell.classList.contains('locked')) return;
        var which = cell.getAttribute('data-eco-cell');
        cells.forEach(function (c) { c.classList.toggle('active', c === cell); });
        bands.forEach(function (b) { b.hidden = b.getAttribute('data-eco-band') !== which; });
      });
    });
  })();

  // === Future of Rhythm — roadmap controller ===
  // Manages the 21-stage stepper:
  //   • cans-sold counter, rendered from the real synced metafield value only
  //     (data-future-initial-sold). NO client-side fabrication — see P1-22.
  //   • per-node status (unlocked / current / loading / locked) from sold vs threshold
  //   • click-to-inspect detail panel swap
  //   • prev/next arrows + edge-driven horizontal auto-scroll on the rail
  (function initFutureRoadmap() {
    var root = document.querySelector('[data-future-root]');
    if (!root) return;

    var counterEl     = root.querySelector('[data-future-counter]');
    var meterFill     = root.querySelector('[data-future-meter-fill]');
    var meterPrev     = root.querySelector('[data-future-meter-prev]');
    var meterNext     = root.querySelector('[data-future-meter-next]');
    var meterRemEl    = root.querySelector('[data-future-meter-remaining-text]');
    var lineFill      = root.querySelector('[data-future-line-fill]');
    var stepper       = root.querySelector('[data-future-stepper]');
    var arrowPrev     = root.querySelector('[data-future-arrow="prev"]');
    var arrowNext     = root.querySelector('[data-future-arrow="next"]');
    var stepNodes     = Array.prototype.slice.call(root.querySelectorAll('[data-future-step]'));
    var detailPanels  = Array.prototype.slice.call(root.querySelectorAll('[data-future-detail]'));
    if (!stepper || stepNodes.length === 0) return;

    var sold = parseInt(root.getAttribute('data-future-initial-sold'), 10) || 0;
    var stagesCount = stepNodes.length;
    var activeIdx = 0;

    function fmt(n) { return n.toLocaleString('en-CA'); }
    function fmtShort(n) {
      if (n >= 1000000000) return (n / 1000000000).toFixed(n % 1000000000 === 0 ? 0 : 1) + 'B';
      if (n >= 1000000)    return (n / 1000000).toFixed(n % 1000000 === 0 ? 0 : 1) + 'M';
      if (n >= 1000)       return Math.round(n / 1000) + 'K';
      return String(n);
    }
    function thresholdOf(idx) {
      return parseInt(stepNodes[idx].getAttribute('data-future-threshold'), 10) || 0;
    }
    function currentStageIdx() {
      var idx = -1;
      for (var i = 0; i < stagesCount; i++) {
        if (sold >= thresholdOf(i)) idx = i;
      }
      return idx;
    }
    function statusOf(idx) {
      var cur = currentStageIdx();
      if (idx <= cur)         return 'unlocked';
      if (idx === cur + 1)    return 'current';
      if (idx === cur + 2)    return 'loading';
      return 'locked';
    }
    function stageTitle(idx) {
      return (detailPanels[idx] && detailPanels[idx].getAttribute('data-future-stage-title')) || '';
    }
    function blockSummary(idx) {
      var tags = stepNodes[idx].querySelector('[data-future-step-tags]');
      return tags ? tags.textContent.trim() : '';
    }

    var ICON_CHECK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="5 12 10 17 19 7"/></svg>';
    var ICON_HOURGLASS = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M7 3h10M7 21h10"/><path d="M7 3v3.5a5 5 0 0 0 2 4L12 12l3-1.5a5 5 0 0 0 2-4V3"/><path d="M7 21v-3.5a5 5 0 0 1 2-4L12 12l3 1.5a5 5 0 0 1 2 4V21"/></svg>';
    var ICON_LOCK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><rect x="5" y="11" width="14" height="9" rx="1.2"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/></svg>';
    var ICON_PULSE = '<span class="future-step-pulse"></span>';

    function applyNodeStatuses() {
      stepNodes.forEach(function (node, i) {
        var st = statusOf(i);
        node.classList.remove('status-unlocked','status-current','status-loading','status-locked');
        node.classList.add('status-' + st);
        var icon = node.querySelector('[data-future-node-icon]');
        if (icon) {
          if (st === 'unlocked')     icon.innerHTML = ICON_CHECK;
          else if (st === 'current') icon.innerHTML = ICON_PULSE;
          else if (st === 'loading') icon.innerHTML = ICON_HOURGLASS;
          else                       icon.innerHTML = ICON_LOCK;
        }
        var tags = node.querySelector('[data-future-step-tags]');
        if (tags) {
          tags.classList.remove('is-loading','is-deep-locked');
          if (st === 'loading') tags.classList.add('is-loading');
          if (st === 'locked')  tags.classList.add('is-deep-locked');
        }
      });
    }

    function applyDetailStatus(panel, st) {
      var idx = parseInt(panel.getAttribute('data-future-idx'), 10);
      var threshold = parseInt(panel.getAttribute('data-future-threshold'), 10) || 0;
      panel.classList.remove('status-unlocked','status-current','status-loading','status-locked');
      panel.classList.add('status-' + st);

      var statusEl    = panel.querySelector('[data-future-detail-status]');
      var statusLabel = panel.querySelector('[data-future-detail-status-label]');
      if (statusEl) {
        statusEl.classList.remove('status-unlocked','status-current','status-loading','status-locked');
        statusEl.classList.add('status-' + st);
      }
      if (statusLabel) {
        statusLabel.textContent = st === 'unlocked' ? 'Unlocked' : st === 'current' ? 'Up next' : st === 'loading' ? 'Loading' : 'Locked';
      }

      // Threshold number — formatted for unlocked/current; blurred-locked stages show same number
      var thrEl = panel.querySelector('[data-future-detail-threshold]');
      if (thrEl && threshold > 0) thrEl.textContent = fmt(threshold);

      // Cans stage overlays. 'current' (up next) gets a soft blur on the
      // cans but no hourglass overlay, so the right-column blocks read
      // clearly while the imagery stays teased.
      var stage = panel.querySelector('[data-future-cans-stage]');
      var loadOverlay = panel.querySelector('[data-future-cans-loading]');
      var lockOverlay = panel.querySelector('[data-future-cans-lock]');
      if (stage) {
        stage.classList.remove('is-current','is-locked','is-loading','is-deep-locked');
        if (st === 'current') { stage.classList.add('is-current'); }
        if (st === 'loading') { stage.classList.add('is-locked','is-loading'); }
        if (st === 'locked')  { stage.classList.add('is-locked','is-deep-locked'); }
      }
      if (loadOverlay) loadOverlay.hidden = (st !== 'loading');
      if (lockOverlay) lockOverlay.hidden = (st !== 'locked');

      // Non-can tile chips (region / amb / app / event / food) are only shown
      // once the stage is unlocked or up-next; locked + loading stages hide
      // them entirely so they're not even teased.
      var tiles = panel.querySelector('[data-future-tiles]');
      if (tiles) tiles.hidden = (st !== 'unlocked' && st !== 'current');

      // Progress card (current only) + Since card (unlocked only)
      var prog = panel.querySelector('[data-future-detail-progress]');
      var since = panel.querySelector('[data-future-detail-since]');
      if (prog) {
        prog.hidden = (st !== 'current');
        if (st === 'current') {
          var prevThr = idx > 0 ? thresholdOf(idx - 1) : 0;
          var span = Math.max(1, threshold - prevThr);
          var into = Math.min(100, Math.max(0, ((sold - prevThr) / span) * 100));
          var fill = prog.querySelector('[data-future-detail-progress-fill]');
          var have = prog.querySelector('[data-future-detail-progress-have]');
          var need = prog.querySelector('[data-future-detail-progress-need]');
          if (fill) fill.style.width = into.toFixed(1) + '%';
          if (have) have.textContent = fmt(sold) + ' cans';
          if (need) need.textContent = fmt(Math.max(0, threshold - sold)) + ' to unlock →';
        }
      }
      if (since) since.hidden = (st !== 'unlocked');

      // Per-block masks
      var blocks = panel.querySelectorAll('[data-future-block]');
      blocks.forEach(function (block) {
        block.classList.remove('status-unlocked','status-current','status-loading','status-locked');
        block.classList.add('status-' + st);
        var lockMask = block.querySelector('[data-future-block-lockmask]');
        var loadMask = block.querySelector('[data-future-block-loadingmask]');
        var lockLabel = block.querySelector('[data-future-block-lock-label]');
        var loadLabel = block.querySelector('[data-future-block-loading-label]');
        if (lockMask) lockMask.hidden = (st !== 'locked');
        if (loadMask) loadMask.hidden = (st !== 'loading');
        if (lockLabel) lockLabel.textContent = 'Unlocks at ' + fmt(threshold) + ' cans';
        if (loadLabel) loadLabel.textContent = 'Loading · ' + fmt(threshold) + ' cans';
      });

      // Nav labels (prev/next stage display names)
      var navPrev = panel.querySelector('[data-future-nav="prev"] [data-future-nav-name]');
      var navNext = panel.querySelector('[data-future-nav="next"] [data-future-nav-name]');
      if (navPrev) {
        var prevName = idx > 0 ? blockSummary(idx - 1) : '';
        navPrev.textContent = prevName;
        navPrev.classList.remove('is-loading','is-deep-locked');
        if (idx > 0) {
          var prevSt = statusOf(idx - 1);
          if (prevSt === 'loading') navPrev.classList.add('is-loading');
          if (prevSt === 'locked')  navPrev.classList.add('is-deep-locked');
        }
      }
      if (navNext) {
        var nextName = idx < stagesCount - 1 ? blockSummary(idx + 1) : '';
        navNext.textContent = nextName;
        navNext.classList.remove('is-loading','is-deep-locked');
        if (idx < stagesCount - 1) {
          var nextSt = statusOf(idx + 1);
          if (nextSt === 'loading') navNext.classList.add('is-loading');
          if (nextSt === 'locked')  navNext.classList.add('is-deep-locked');
        }
      }
    }

    function setActive(idx) {
      activeIdx = Math.max(0, Math.min(stagesCount - 1, idx));
      stepNodes.forEach(function (n, i) { n.classList.toggle('active', i === activeIdx); });
      detailPanels.forEach(function (p, i) { p.hidden = (i !== activeIdx); });
      applyDetailStatus(detailPanels[activeIdx], statusOf(activeIdx));
      // Scroll the active node into view inside the rail
      var node = stepNodes[activeIdx];
      if (node && stepper) {
        var nodeRect = node.getBoundingClientRect();
        var stepperRect = stepper.getBoundingClientRect();
        if (nodeRect.left < stepperRect.left + 60 || nodeRect.right > stepperRect.right - 60) {
          var target = node.offsetLeft - stepper.clientWidth / 2 + node.clientWidth / 2;
          stepper.scrollTo({ left: target, behavior: 'smooth' });
        }
      }
    }

    function updateMeter() {
      if (counterEl) counterEl.textContent = fmt(sold);
      var cur = currentStageIdx();
      var nextIdx = cur + 1;
      var nextThr = nextIdx < stagesCount ? thresholdOf(nextIdx) : thresholdOf(stagesCount - 1);
      var prevThr = cur >= 0 ? thresholdOf(cur) : 0;
      var pct = nextIdx < stagesCount ? Math.min(100, ((sold - prevThr) / Math.max(1, nextThr - prevThr)) * 100) : 100;
      if (meterFill) meterFill.style.width = pct.toFixed(2) + '%';
      if (meterPrev) meterPrev.textContent = fmt(prevThr) + ' cans';
      if (meterNext) meterNext.textContent = fmt(nextThr) + ' cans → next unlock';
      if (meterRemEl) {
        if (nextIdx < stagesCount) {
          var remaining = Math.max(0, nextThr - sold);
          meterRemEl.innerHTML = fmt(remaining) + ' cans to unlock <strong class="future-meter-rem-strong">' + stageTitle(nextIdx) + '</strong>';
        } else {
          meterRemEl.textContent = 'System complete.';
        }
      }
      // Stepper-line fill
      if (lineFill) {
        var totalSpans = Math.max(1, stagesCount - 1);
        var segPct = nextIdx < stagesCount
          ? ((sold - prevThr) / Math.max(1, nextThr - prevThr))
          : 1;
        var linePct = Math.min(100, ((Math.max(0, cur) + Math.max(0, Math.min(1, segPct))) / totalSpans) * 100);
        lineFill.style.width = linePct.toFixed(2) + '%';
      }
    }

    function rerender() {
      updateMeter();
      applyNodeStatuses();
      applyDetailStatus(detailPanels[activeIdx], statusOf(activeIdx));
    }

    // Wire nodes + nav buttons
    stepNodes.forEach(function (node) {
      node.addEventListener('click', function () {
        setActive(parseInt(node.getAttribute('data-future-idx'), 10) || 0);
      });
    });
    detailPanels.forEach(function (panel) {
      var prev = panel.querySelector('[data-future-nav="prev"]');
      var next = panel.querySelector('[data-future-nav="next"]');
      if (prev) prev.addEventListener('click', function () { setActive(activeIdx - 1); });
      if (next) next.addEventListener('click', function () { setActive(activeIdx + 1); });
    });

    // Stepper arrows + edge-driven scroll
    function updateArrowState() {
      if (!stepper) return;
      var atStart = stepper.scrollLeft <= 2;
      var atEnd   = stepper.scrollLeft >= stepper.scrollWidth - stepper.clientWidth - 2;
      if (arrowPrev) {
        arrowPrev.classList.toggle('is-disabled', atStart);
        arrowPrev.disabled = atStart;
      }
      if (arrowNext) {
        arrowNext.classList.toggle('is-disabled', atEnd);
        arrowNext.disabled = atEnd;
      }
    }
    if (arrowPrev) arrowPrev.addEventListener('click', function () {
      stepper.scrollBy({ left: -Math.round(stepper.clientWidth * 0.7), behavior: 'smooth' });
    });
    if (arrowNext) arrowNext.addEventListener('click', function () {
      stepper.scrollBy({ left:  Math.round(stepper.clientWidth * 0.7), behavior: 'smooth' });
    });
    stepper.addEventListener('scroll', updateArrowState, { passive: true });
    window.addEventListener('resize', updateArrowState);

    // Edge-driven auto-scroll: when the cursor approaches either edge of the
    // rail, scroll that direction. Speed ramps up the closer to the edge.
    (function initEdgeScroll() {
      var EDGE = 120, MAX_VEL = 14;
      var hovering = false, vel = 0, raf = 0;
      function onMove(e) {
        var rect = stepper.getBoundingClientRect();
        var x = e.clientX - rect.left;
        var w = rect.width;
        if (x < EDGE)            vel = -((EDGE - x) / EDGE) * MAX_VEL;
        else if (x > w - EDGE)   vel =  ((x - (w - EDGE)) / EDGE) * MAX_VEL;
        else                     vel = 0;
        hovering = true;
      }
      function onLeave() { hovering = false; vel = 0; }
      function tick() {
        if (hovering && vel !== 0) {
          var max = stepper.scrollWidth - stepper.clientWidth;
          stepper.scrollLeft = Math.min(max, Math.max(0, stepper.scrollLeft + vel));
        }
        raf = requestAnimationFrame(tick);
      }
      stepper.addEventListener('mousemove', onMove);
      stepper.addEventListener('mouseleave', onLeave);
      raf = requestAnimationFrame(tick);
    })();

    // Initial: default to the "current" stage so users land on what's up next
    var cur = currentStageIdx();
    var nextIdx = Math.min(stagesCount - 1, cur + 1);
    activeIdx = nextIdx >= 0 ? nextIdx : 0;
    rerender();
    // Make sure the active node is on screen, but after layout settles
    setTimeout(function () { setActive(activeIdx); updateArrowState(); }, 50);

    // P1-22: NO live ticker. `sold` is the real, monthly-synced metafield value
    // and MUST NOT be mutated client-side — the old setInterval added
    // Math.random() cans on top of the true count, fabricating the public
    // all-time total AND (via statusOf/currentStageIdx) flipping roadmap stages
    // to "unlocked" without any real milestone. If a "live feel" is ever wanted,
    // animate a CSS shimmer only — never the number, and never feed statusOf().
  })();

  // === Store locator: cascading filters + client-side search ===
  (function initLocator() {
    var root = document.querySelector('[data-locator]');
    if (!root) return;
    var provinceEl = $('[data-loc-province]');
    var cityEl     = $('[data-loc-city]');
    var qEl        = $('[data-loc-q]');
    var summaryEl  = $('[data-loc-summary]');
    var clearBtn   = $('[data-loc-clear]');
    var emptyEl    = $('[data-loc-empty]');
    var clearBtn2  = $('[data-loc-clear-2]');
    var cards      = $$('[data-loc-card]');
    var groups     = $$('[data-loc-group]');
    var sub = 'All';

    function uniqueCities(province) {
      var set = {};
      cards.forEach(function (c) {
        if (province !== 'All' && c.dataset.locProvince !== province) return;
        set[c.dataset.locCity] = true;
      });
      return Object.keys(set).sort();
    }

    function rebuildCities() {
      var province = provinceEl.value;
      var current = cityEl.value;
      var cities = uniqueCities(province);
      cityEl.innerHTML = '<option value="All">All cities</option>' + cities.map(function (c) { return '<option>' + loyaltyEscapeHtml(c) + '</option>'; }).join('');
      if (cities.indexOf(current) === -1) cityEl.value = 'All';
    }

    function update() {
      var province = provinceEl.value;
      var city = cityEl.value;
      var q = (qEl.value || '').trim().toLowerCase();
      var filterCount = (province !== 'All' ? 1 : 0) + (city !== 'All' ? 1 : 0) + (sub !== 'All' ? 1 : 0) + (q ? 1 : 0);
      var visible = 0;
      cards.forEach(function (c) {
        var ok = true;
        if (province !== 'All' && c.dataset.locProvince !== province) ok = false;
        if (ok && city !== 'All' && c.dataset.locCity !== city) ok = false;
        if (ok && sub !== 'All' && c.dataset.locSubs.indexOf(sub) === -1) ok = false;
        if (ok && q) {
          var hay = (c.dataset.locName + ' ' + c.dataset.locAddr + ' ' + c.dataset.locCity + ' ' + c.dataset.locProvince + ' ' + c.dataset.locType + ' ' + c.dataset.locNote).toLowerCase();
          if (hay.indexOf(q) === -1) ok = false;
        }
        c.hidden = !ok;
        if (ok) visible++;
      });
      groups.forEach(function (g) {
        var anyVisible = Array.prototype.some.call(g.querySelectorAll('[data-loc-card]'), function (c) { return !c.hidden; });
        g.hidden = !anyVisible;
      });
      summaryEl.textContent = visible + ' of ' + cards.length + ' locations' + (filterCount > 0 ? ' · ' + filterCount + ' filter' + (filterCount > 1 ? 's' : '') + ' applied' : '');
      if (clearBtn) clearBtn.hidden = filterCount === 0;
      if (emptyEl) emptyEl.hidden = visible > 0;
    }

    function clearAll() {
      provinceEl.value = 'All';
      rebuildCities();
      sub = 'All';
      $$('[data-loc-sub]').forEach(function (b) { b.classList.toggle('active', b.dataset.locSub === 'All'); });
      qEl.value = '';
      update();
    }

    provinceEl.addEventListener('change', function () { rebuildCities(); update(); });
    cityEl.addEventListener('change', update);
    qEl.addEventListener('input', update);
    $$('[data-loc-sub]').forEach(function (b) {
      b.addEventListener('click', function () {
        sub = b.dataset.locSub;
        $$('[data-loc-sub]').forEach(function (x) { x.classList.toggle('active', x === b); });
        update();
      });
    });
    if (clearBtn) clearBtn.addEventListener('click', clearAll);
    if (clearBtn2) clearBtn2.addEventListener('click', clearAll);

    rebuildCities();
    update();
  })();

  // === Build a Bundle builder ===
  // Each .bundle-can carries data-handle + data-variant-id. Stepper increments
  // case count per flavor. Tier discount auto-applies based on total cases.
  // Add to cart: POST to /cart/add.js with items[] = each flavor × (cases × 6 four-packs).
  // ONE-TIME ONLY (ST-010, 2026-10-02): no subscribe mode, cadence or subscription pricing.
  // TODO: For real discount enforcement at checkout, Shopify automatic discounts
  // must be configured in admin (or replaced by the future backend draft-order flow).
  (function initBundle() {
    var builder = $('[data-bundle-builder]');
    if (!builder) return;

    var PRICE_PER_CASE = 120;
    var PACKS_PER_CASE = 6;
    var CANS_PER_CASE = 24;
    var MAX_CASES = 4;
    var TIERS = [
      { n: 1, label: 'The Starter', pct: 10 },
      { n: 2, label: 'The Pair',    pct: 15 },
      { n: 3, label: 'The Stack',   pct: 20 },
      { n: 4, label: 'The Rhythm',  pct: 25 }
    ];

    var cans = $$('[data-bundle-can]', builder);
    var qtys = {};
    cans.forEach(function (c) { qtys[c.dataset.handle] = 0; });

    function totalCases() {
      return Object.keys(qtys).reduce(function (s, k) { return s + qtys[k]; }, 0);
    }
    function currentTier(cases) {
      var t = null;
      TIERS.forEach(function (T) { if (cases >= T.n) t = T; });
      return t;
    }
    function nextTier(cases) {
      for (var i = 0; i < TIERS.length; i++) if (cases < TIERS[i].n) return TIERS[i];
      return null;
    }

    function setCanState(c) {
      var q = qtys[c.dataset.handle];
      var valEl = c.querySelector('[data-bundle-qty-val]');
      valEl.firstChild.textContent = q + ' ';
      var unit = valEl.querySelector('.bundle-stepper-unit');
      if (unit) unit.textContent = 'case' + (q === 1 ? '' : 's');
      c.classList.toggle('has-qty', q > 0);
      var minus = c.querySelector('[data-bundle-qty="-1"]');
      if (minus) minus.disabled = q <= 0;
      var atCap = totalCases() >= MAX_CASES && q === 0;
      var plus = c.querySelector('[data-bundle-qty="1"]');
      if (plus) plus.disabled = atCap;
    }

    function update() {
      var tc = totalCases();
      var ct = currentTier(tc);
      var nt = nextTier(tc);
      var listPrice = tc * PRICE_PER_CASE;
      var discount = ct ? ct.pct / 100 : 0;
      var finalPay = Math.round(listPrice * (1 - discount));
      var savings = listPrice - finalPay;

      // Header / pay — selectors renamed from data-bundle-* to
      // data-tier-progress-* when the tier-progress visualization was
      // extracted to snippets/tier-progress-bar.liquid (shared with the
      // cart page). The bundle-builder still owns its driving logic; only
      // the DOM hooks moved.
      var payEl = $('[data-tier-progress-pay]'); if (payEl) payEl.textContent = '$' + finalPay;
      var currentTierEl = $('[data-tier-progress-current-tier]');
      if (currentTierEl) {
        currentTierEl.innerHTML = ct
          ? '<em class="serif-display">' + ct.label + '</em> &middot; ' + ct.pct + '% off'
          : '<span style="color:var(--fg-mute);">No tier yet</span>';
      }

      // Track + nodes
      var pct = Math.min(100, (tc / MAX_CASES) * 100);
      var fill = $('[data-tier-progress-fill]'); if (fill) fill.style.width = pct + '%';
      TIERS.forEach(function (T) {
        var node = $('[data-tier-progress-node="' + T.n + '"]');
        if (!node) return;
        node.classList.toggle('is-reached', tc >= T.n);
        node.classList.toggle('is-current', ct && ct.n === T.n);
      });

      // Prompt
      var promptEl = $('[data-tier-progress-prompt]');
      if (promptEl) {
        if (tc === 0) promptEl.textContent = 'Start by adding a case. Any flavor.';
        else if (ct && !nt) promptEl.textContent = "You're at the top tier, The Rhythm. Maximum savings unlocked.";
        else if (ct && nt) {
          var d = nt.n - tc;
          promptEl.textContent = 'Add ' + d + ' more case' + (d === 1 ? '' : 's') + ' to reach ' + nt.label + ' and save ' + (nt.pct - ct.pct) + '% more.';
        } else {
          var d2 = nt.n - tc;
          promptEl.textContent = 'Add ' + d2 + ' more case' + (d2 === 1 ? '' : 's') + ' to reach ' + nt.label + ' to unlock ' + nt.pct + '% off.';
        }
      }

      // Counter
      var countEl = $('[data-bundle-count]'); if (countEl) countEl.textContent = String(tc).padStart(2, '0');
      var detailEl = $('[data-bundle-count-detail]');
      if (detailEl) detailEl.textContent = tc + ' case' + (tc === 1 ? '' : 's') + ' · ' + (tc * PACKS_PER_CASE) + ' × 4-pack' + (tc * PACKS_PER_CASE === 1 ? '' : 's') + ' · ' + (tc * CANS_PER_CASE) + ' cans';

      // Selection list
      var selEl = $('[data-bundle-selection]');
      if (selEl) {
        if (tc === 0) {
          selEl.innerHTML = '<div class="bundle-empty">Start by adding a case. Any flavor.</div>';
        } else {
          var rows = '';
          cans.forEach(function (c) {
            var q = qtys[c.dataset.handle];
            if (q <= 0) return;
            var title = c.querySelector('.bundle-can-title').textContent.trim();
            var sub = c.dataset.sub.toUpperCase();
            rows += '<div class="bundle-summary-row"><span>' + loyaltyEscapeHtml(sub) + ' &middot; <em>' + loyaltyEscapeHtml(title) + '</em></span><span class="qty">× ' + q + ' case' + (q === 1 ? '' : 's') + '</span></div>';
          });
          selEl.innerHTML = rows;
        }
      }

      // Totals
      var totalEl = $('[data-bundle-total]'); if (totalEl) totalEl.textContent = '$' + finalPay;
      var savingsEl = $('[data-bundle-savings]');
      if (savingsEl) {
        if (savings > 0) {
          savingsEl.textContent = 'You save $' + savings;
          savingsEl.classList.remove('is-zero');
        } else {
          savingsEl.textContent = 'No tier discount yet';
          savingsEl.classList.add('is-zero');
        }
      }

      // Math row highlight
      $$('[data-bundle-math-tier]').forEach(function (r) {
        var on = ct && r.dataset.bundleMathTier === String(ct.n);
        r.classList.toggle('is-current', !!on);
        var mark = r.querySelector('.bundle-math-mark');
        if (mark) mark.innerHTML = on ? '<span class="bundle-math-here">You&rsquo;re here</span>' : '';
      });

      // Tier card active
      $$('[data-tier-fill]').forEach(function (card) {
        card.classList.toggle('is-active', ct && card.dataset.tierFill === String(ct.n));
      });

      // Add-to-cart button
      var btn = $('[data-bundle-add]');
      if (btn) {
        btn.disabled = tc === 0;
        btn.innerHTML = tc === 0
          ? 'Add a case to start <span class="arr">→</span>'
          : ct
            ? 'Lock in ' + ct.label + ' <span class="arr">→</span>'
            : 'Add to cart <span class="arr">→</span>';
      }

      // Refresh disabled state on all steppers
      cans.forEach(setCanState);
    }

    function setQty(handle, q) {
      var others = 0;
      Object.keys(qtys).forEach(function (k) { if (k !== handle) others += qtys[k]; });
      var room = MAX_CASES - others;
      qtys[handle] = Math.max(0, Math.min(room, q));
      update();
    }

    // Wire steppers
    cans.forEach(function (c) {
      c.querySelectorAll('[data-bundle-qty]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          setQty(c.dataset.handle, qtys[c.dataset.handle] + parseInt(btn.dataset.bundleQty, 10));
        });
      });
    });

    // Preset quick-fills
    function presetFill(preset) {
      var rise = cans.filter(function (c) { return c.dataset.sub === 'rise'; });
      var drift = cans.filter(function (c) { return c.dataset.sub === 'drift'; });
      var next = {};
      cans.forEach(function (c) { next[c.dataset.handle] = 0; });
      if (preset === 'pair') {
        if (rise[0]) next[rise[0].dataset.handle] = 1;
        if (drift[0]) next[drift[0].dataset.handle] = 1;
      } else if (preset === 'rise-trio') {
        rise.forEach(function (c) { next[c.dataset.handle] = 1; });
      } else if (preset === 'drift-trio') {
        drift.forEach(function (c) { next[c.dataset.handle] = 1; });
      } else if (preset === 'rhythm') {
        if (rise[0]) next[rise[0].dataset.handle] = 1;
        if (rise[1]) next[rise[1].dataset.handle] = 1;
        if (drift[0]) next[drift[0].dataset.handle] = 1;
        if (drift[1]) next[drift[1].dataset.handle] = 1;
      } else if (preset === 'all-rise') {
        if (rise[0]) next[rise[0].dataset.handle] = 2;
        if (rise[1]) next[rise[1].dataset.handle] = 1;
        if (rise[2]) next[rise[2].dataset.handle] = 1;
      } else if (preset === 'all-drift') {
        if (drift[0]) next[drift[0].dataset.handle] = 2;
        if (drift[1]) next[drift[1].dataset.handle] = 1;
        if (drift[2]) next[drift[2].dataset.handle] = 1;
      }
      qtys = next;
      update();
    }
    $$('[data-bundle-preset]').forEach(function (btn) {
      btn.addEventListener('click', function () { presetFill(btn.dataset.bundlePreset); });
    });

    // Tier card click → balanced fill
    $$('[data-tier-fill]').forEach(function (card) {
      card.addEventListener('click', function () {
        var n = parseInt(card.dataset.tierFill, 10);
        var rise = cans.filter(function (c) { return c.dataset.sub === 'rise'; });
        var drift = cans.filter(function (c) { return c.dataset.sub === 'drift'; });
        var next = {};
        cans.forEach(function (c) { next[c.dataset.handle] = 0; });
        if (n === 1 && rise[0]) next[rise[0].dataset.handle] = 1;
        else if (n === 2) { if (rise[0]) next[rise[0].dataset.handle] = 1; if (drift[0]) next[drift[0].dataset.handle] = 1; }
        else if (n === 3) { if (rise[0]) next[rise[0].dataset.handle] = 1; if (rise[1]) next[rise[1].dataset.handle] = 1; if (drift[0]) next[drift[0].dataset.handle] = 1; }
        else if (n === 4) { if (rise[0]) next[rise[0].dataset.handle] = 1; if (rise[1]) next[rise[1].dataset.handle] = 1; if (drift[0]) next[drift[0].dataset.handle] = 1; if (drift[1]) next[drift[1].dataset.handle] = 1; }
        qtys = next;
        update();
      });
    });

    // === Reset bundle WIP state to idle ===
    // Called from the add-to-cart success path so the customer can build
    // another bundle without refreshing the page. Previously the click
    // handler set the button to disabled + 'Adding...' on click but
    // never reset it on success — the page locked with stale qtys state
    // + stuck button until full refresh.
    //
    // resetBundle() zeroes the qtys dict and re-runs update(); update()
    // then redraws the tier-progress visualization, can counter,
    // selection list, math row, tier-fill cards, and sets the add-to-cart
    // button to its disabled "Add a case to start →" idle label (will
    // re-enable as soon as the customer adjusts a stepper).
    //
    // Not wired to circadia:cart-changed events — cart-clear from drawer
    // does NOT auto-reset bundle WIP. Filed as a follow-up; if the
    // use case proves important, add a listener that calls resetBundle()
    // when the cart becomes empty externally.
    function resetBundle() {
      Object.keys(qtys).forEach(function (k) { qtys[k] = 0; });
      update();
    }

    // Add to cart — each case = 6 × 4-packs of that flavor variant.
    //
    // Inventory shortfall flow: snapshot /cart.js before the add, run
    // the add (Shopify returns 422 with partial fulfillment when stock
    // is short; we treat 422 + 200 identically — both proceed to drawer
    // refresh), snapshot /cart.js again, diff per-variant. Any
    // shortfall fires 'circadia:inventory-shortfall' which the
    // module-level handler renders into the drawer's notice container.
    // Falls back to status-quo behavior (no shortfall detection) if
    // either snapshot fails — under-reporting is safer than over-
    // reporting from a bad delta.
    $('[data-bundle-add]').addEventListener('click', function () {
      var items = [];
      cans.forEach(function (c) {
        var q = qtys[c.dataset.handle];
        if (q > 0) items.push({ id: parseInt(c.dataset.variantId, 10), quantity: q * PACKS_PER_CASE });
      });
      if (!items.length) return;
      var btn = this;
      btn.disabled = true;
      btn.innerHTML = 'Adding...';

      var requested = {};
      items.forEach(function (it) { requested[it.id] = it.quantity; });

      // Plain one-time items, nothing else: the builder has no subscription mode (ST-010).
      var addBody = { items: items };

      function openAndRefreshDrawer() {
        document.body.classList.add('cart-open');
        var d = $('[data-cart-drawer]'); var o = $('[data-cart-overlay]');
        if (d) d.classList.add('open');
        if (o) o.classList.add('open');
        // Re-render drawer via Section Rendering API. refreshDrawer
        // dispatches 'circadia:cart-changed' for case-aggregation.js to
        // recompute the discount.
        refreshDrawer();
        // Reset bundle WIP state so the customer can build another
        // bundle without refreshing — the catch path below leaves WIP
        // intact for retry, but every success path lands here.
        resetBundle();
      }

      snapshotCart().then(function (pre) {
        if (pre === null) {
          // Pre-snapshot failed; we can't compute a per-variant delta
          // reliably. Fall back to status-quo: add + refresh, no
          // shortfall detection this attempt.
          console.warn('[bundle-builder] Pre-snapshot failed, skipping shortfall detection');
          return fetch(window.routes.cart_add_url + '.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify(addBody),
          }).then(function (r) {
            if (r.status >= 500) {
              return r.text().then(function (t) { throw new Error('cart/add.js HTTP ' + r.status + ': ' + t); });
            }
            return r.json().catch(function () { return {}; });
          }).then(openAndRefreshDrawer);
        }

        // Pre-snapshot OK — run the add, capture status + body, then
        // post-snapshot + diff.
        return fetch(window.routes.cart_add_url + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(addBody),
        }).then(function (r) {
          if (r.status >= 500) {
            return r.text().then(function (t) { throw new Error('cart/add.js HTTP ' + r.status + ': ' + t); });
          }
          return r.json().catch(function () { return {}; }).then(function (body) {
            return { ok: r.ok, status: r.status, body: body };
          });
        }).then(function (addResult) {
          if (addResult.status === 422 && addResult.body && addResult.body.description) {
            console.warn('[bundle-builder] Cart add returned 422:', addResult.body.description);
          }
          return snapshotCart().then(function (post) {
            if (post === null) {
              // Post-snapshot failed; can't compute shortfall. Still
              // open + refresh — the add itself may have succeeded.
              console.warn('[bundle-builder] Post-snapshot failed, skipping shortfall detection');
              openAndRefreshDrawer();
              return;
            }
            // Compute per-variant shortfalls. anchorQty is the cart
            // quantity for this variant immediately after the add —
            // the value that, if it changes, signals the customer
            // acknowledged the shortfall.
            var shortfalls = [];
            Object.keys(requested).forEach(function (vid) {
              var preQty = pre.snap[vid] || 0;
              var postQty = post.snap[vid] || 0;
              var actualAdded = postQty - preQty;
              var requestedQty = requested[vid];
              if (actualAdded < requestedQty) {
                var match = (post.items || []).find(function (it) {
                  return String(it.variant_id) === String(vid);
                });
                shortfalls.push({
                  variantId: vid,
                  flavorName: match ? match.product_title : 'Unknown item',
                  requested: requestedQty,
                  actual: Math.max(0, actualAdded),
                  anchorQty: postQty,
                });
              }
            });
            if (shortfalls.length > 0) {
              activeShortfalls = shortfalls;
              document.dispatchEvent(new CustomEvent('circadia:inventory-shortfall', {
                detail: { shortfall: shortfalls },
              }));
            }
            openAndRefreshDrawer();
          });
        });
      }).catch(function () {
        btn.disabled = false;
        update();
      });
    });

    update();
  })();

  // === Ingredient card flip (science page) ===
  document.addEventListener('click', function (e) {
    var card = e.target.closest('[data-ing-card]');
    if (!card) return;
    if (e.target.closest('a')) return; // let inner links work
    card.classList.toggle('flipped');
    card.setAttribute('aria-pressed', card.classList.contains('flipped') ? 'true' : 'false');
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var card = e.target.closest('[data-ing-card]');
    if (!card) return;
    e.preventDefault();
    card.classList.toggle('flipped');
  });

  // === Science page Rise/Drift stack toggle ===
  // Fade the active grid out, swap content, fade in. Matches the design's
  // soft transition between the two stacks.
  var sciSwitching = false;
  document.addEventListener('click', function (e) {
    var tab = e.target.closest('[data-sci-tab]');
    if (!tab || sciSwitching) return;
    var which = tab.dataset.sciTab; // rise | drift
    var container = document.querySelector('[data-sci-stack]');
    if (!container) return;
    if (container.dataset.stack === which) return;
    sciSwitching = true;

    var grids = $$('[data-sci-grid]');
    // Mark the currently visible grid(s) as fading
    grids.forEach(function (g) {
      if (g.style.display !== 'none') g.classList.add('is-fading');
    });

    setTimeout(function () {
      container.dataset.stack = which;
      $$('[data-sci-tab]').forEach(function (t) {
        var on = t === tab;
        t.classList.toggle('active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      var label = document.querySelector('[data-sci-label]');
      if (label) label.textContent = which.toUpperCase();
      var accent = document.querySelector('[data-sci-accent]');
      if (accent) accent.style.color = which === 'rise' ? 'var(--rise)' : 'var(--drift)';
      var rPath = document.querySelector('[data-sci-rise]');
      var dPath = document.querySelector('[data-sci-drift]');
      if (rPath && dPath) {
        rPath.style.display = which === 'rise' ? '' : 'none';
        dPath.style.display = which === 'drift' ? '' : 'none';
      }
      // Swap which grid is shown, then fade in on the next frame.
      grids.forEach(function (g) {
        var matches = g.dataset.sciGrid === which;
        g.style.display = matches ? '' : 'none';
        if (matches) g.classList.add('is-fading'); // start at faded state
      });
      requestAnimationFrame(function () {
        grids.forEach(function (g) { g.classList.remove('is-fading'); });
        sciSwitching = false;
      });
    }, 240);
  });

  // === FAQ category nav ===
  // Sidebar click opens the matching category (which is itself a <details> in
  // an exclusive group via the name="faq-cat-group" attribute, so opening one
  // closes the others). Sidebar active state mirrors whichever category is
  // currently open.
  (function initFaq() {
    var nav = $$('[data-faq-cat-link]');
    if (!nav.length) return;

    function setActiveLink(id) {
      nav.forEach(function (l) { l.classList.toggle('active', l.dataset.faqCatLink === id); });
    }

    nav.forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        var target = document.getElementById(link.dataset.faqCatLink);
        if (!target) return;
        target.open = true;
        setActiveLink(link.dataset.faqCatLink);
        // Small delay so the scroll lands after the details has opened.
        setTimeout(function () { target.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 50);
      });
    });

    $$('[data-faq-cat]').forEach(function (cat) {
      cat.addEventListener('toggle', function () {
        if (cat.open) setActiveLink(cat.id);
      });
    });
  })();

  // === FAQ search filter ===
  document.addEventListener('input', function (e) {
    var input = e.target.closest('[data-faq-search]');
    if (!input) return;
    var q = input.value.trim().toLowerCase();
    $$('.faq-q').forEach(function (item) {
      var text = item.textContent.toLowerCase();
      var hit = q === '' || text.indexOf(q) !== -1;
      item.hidden = !hit;
      if (hit && q !== '') item.setAttribute('open', '');
    });
  });

  // === Ambassador apply form ===
  // AREA 3 Slice A — real submit: POST the form to the App Proxy
  // (/apps/dashboard/ambassador/apply → proxy/index.ts → buildAmbassadorApplyHandler).
  // AUTHENTICATED: Shopify's App Proxy attaches logged_in_customer_id only when
  // the visitor is signed in, so an anonymous submit comes back 401 — we prompt
  // them to sign in. 409 means they've already applied. 200 reveals the success
  // state from the design.
  function showAmbassadorError(form, message) {
    var box = document.querySelector('[data-ambassador-error]');
    if (box) {
      box.textContent = message;
      box.hidden = false;
      box.scrollIntoView({ behavior: 'smooth', block: 'center' });
    } else if (window.console && window.console.warn) {
      console.warn('[ambassador-apply] ' + message);
    }
  }
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-ambassador-apply]');
    if (!form) return;
    e.preventDefault();

    var errBox = document.querySelector('[data-ambassador-error]');
    if (errBox) errBox.hidden = true;

    var payload = {};
    new FormData(form).forEach(function (value, key) { payload[key] = value; });
    // Checkboxes arrive as 'on' when checked; send real booleans.
    payload.agree = Boolean(payload.agree);
    payload.agreement_accepted = Boolean(payload.agreement_accepted);

    var submitBtn = form.querySelector('button[type="submit"]');
    var originalLabel = submitBtn ? submitBtn.innerHTML : null;
    if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Submitting…'; }

    function restoreButton() {
      if (submitBtn) { submitBtn.disabled = false; submitBtn.innerHTML = originalLabel; }
    }

    fetch('/apps/dashboard/ambassador/apply', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(payload),
    }).then(function (r) {
      return r.json().then(function (json) { return { status: r.status, ok: r.ok, json: json }; })
        .catch(function () { return { status: r.status, ok: r.ok, json: null }; });
    }).then(function (res) {
      if (res.ok && res.json && res.json.ok) {
        form.hidden = true;
        var success = document.querySelector('[data-ambassador-success]');
        if (success) {
          success.hidden = false;
          success.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
        return;
      }
      restoreButton();
      if (res.status === 401) {
        showAmbassadorError(form, 'Please sign in to your Circadia account first, then submit your application.');
      } else if (res.status === 409) {
        showAmbassadorError(form, "Looks like you've already applied with this account. Check your email for our reply, or reach out if it's been more than 14 days.");
      } else {
        var msg = (res.json && res.json.error) ? res.json.error : "Something went wrong submitting your application. Please try again.";
        showAmbassadorError(form, msg);
      }
    }).catch(function () {
      restoreButton();
      showAmbassadorError(form, 'Network error. Please check your connection and try again.');
    });
  });

  // === Home hero carousel ===
  // Rotate slides every 7s; manual prev/next arrows reset the timer.
  function initHeroCarousels() {
    $$('[data-hero-carousel]').forEach(function (carousel) {
      var slides = $$('[data-hero-slide]', carousel);
      if (slides.length < 2) return;
      var idx = 0;
      var timer;
      function show(i) {
        idx = (i + slides.length) % slides.length;
        slides.forEach(function (s, n) { s.classList.toggle('active', n === idx); });
      }
      function schedule() { clearTimeout(timer); timer = setTimeout(function () { show(idx + 1); schedule(); }, 7000); }
      // Arrows are now duplicated per slide so they align inline with each
      // slide's CTA row. Wire every prev/next button to the same handlers.
      $$('[data-hero-prev]', carousel).forEach(function (btn) {
        btn.addEventListener('click', function () { show(idx - 1); schedule(); });
      });
      $$('[data-hero-next]', carousel).forEach(function (btn) {
        btn.addEventListener('click', function () { show(idx + 1); schedule(); });
      });
      schedule();
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeroCarousels);
  } else {
    initHeroCarousels();
  }

  // TODO: Replace this client-side referral capture with server-side click logging
  // via POST to /api/clicks when the backend exists (see docs/ARCHITECTURE.md session 3).
  //
  // One transport for both referral programs, each with its own param, storage
  // key and cart attribute so they never collide: ambassadors (?ref=) and
  // Refer-a-Friend (?raf=, appended by the /r/:slug dispatcher). Window per
  // docs/PROGRAM_TERMS.md: 7 days from capture, no rolling extension; a new
  // param overwrites and restarts it. The capture time rides along as
  // <attr>_at so orders/paid can enforce the window server-side rather than
  // trusting this browser's storage. sessionStorage remembers what this tab
  // last wrote, so the cart is POSTed only when attribution changes.
  function captureReferralParam(opts) {
    var WINDOW_MS = 7 * 24 * 60 * 60 * 1000;
    var SLUG_RE = /^[a-z0-9][a-z0-9-]{0,39}$/;
    var writtenKey = 'circadia_cart_attr_' + opts.attr;

    // Touching storage at all can throw (Safari private mode, blocked site data).
    function storageGet(area, key) {
      try { return window[area].getItem(key); } catch (e) { return null; }
    }
    function storageSet(area, key, value) {
      try { window[area].setItem(key, value); } catch (e) { /* unavailable */ }
    }
    function storageRemove(area, key) {
      try { window[area].removeItem(key); } catch (e) { /* unavailable */ }
    }

    // Shopify's cart cookie: a checkout starts a new cart in the same tab, and
    // that cart must get the attribution written again.
    function cartToken() {
      try {
        var m = document.cookie.match(/(?:^|;\s*)cart=([^;]*)/);
        return m ? m[1] : '';
      } catch (e) { return ''; }
    }

    function normalizeSlug(value) {
      if (typeof value !== 'string') return null;
      var slug = value.trim().toLowerCase();
      return SLUG_RE.test(slug) ? slug : null;
    }

    function readStored(now) {
      var raw = storageGet('localStorage', opts.storageKey);
      if (raw === null) return null;
      var parsed = null;
      try { parsed = JSON.parse(raw); } catch (e) { parsed = null; }
      var slug = parsed ? normalizeSlug(parsed.slug) : null;
      var expiresAt = parsed ? parsed.expires_at : NaN;
      if (!slug || typeof expiresAt !== 'number' || !isFinite(expiresAt) || now > expiresAt) {
        storageRemove('localStorage', opts.storageKey);
        return null;
      }
      var capturedMs = typeof parsed.captured_at === 'string' ? new Date(parsed.captured_at).getTime() : NaN;
      // Payloads stored before captured_at existed: the window was always
      // exactly 7 days, so the capture time is recoverable from expires_at.
      if (isNaN(capturedMs)) capturedMs = expiresAt - WINDOW_MS;
      return { slug: slug, captured_at: new Date(capturedMs).toISOString(), expires_at: expiresAt };
    }

    function postAttributes(slug, capturedAt, onWritten) {
      if (!(window.routes && window.routes.cart_update_url) || typeof fetch !== 'function') return;
      var attributes = {};
      attributes[opts.attr] = slug;
      attributes[opts.attr + '_at'] = capturedAt;
      fetch(window.routes.cart_update_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ attributes: attributes })
      }).then(function (res) {
        if (res && res.ok) onWritten();
      }).catch(function () { /* retried on the next page view */ });
    }

    try {
      var now = Date.now();
      var incoming = new URLSearchParams(window.location.search).get(opts.param);
      var fresh = incoming ? normalizeSlug(incoming) : null;
      var current;
      if (fresh) {
        current = { slug: fresh, captured_at: new Date(now).toISOString(), expires_at: now + WINDOW_MS };
        storageSet('localStorage', opts.storageKey, JSON.stringify(current));
      } else {
        current = readStored(now);
      }

      var written = storageGet('sessionStorage', writtenKey);
      if (!current) {
        // Shopify drops a cart attribute set to ''. Clear only what this tab
        // wrote, so visitors without attribution never POST the cart.
        if (written !== null) {
          postAttributes('', '', function () { storageRemove('sessionStorage', writtenKey); });
        }
        return;
      }
      var base = current.slug + '|' + current.captured_at + '|';
      if (written === base + cartToken()) return;
      postAttributes(current.slug, current.captured_at, function () {
        // Read after the POST: /cart/update.js creates the cart (and its cookie) when none existed.
        storageSet('sessionStorage', writtenKey, base + cartToken());
      });
    } catch (e) { /* attribution is best-effort and must never break the page */ }
  }

  captureReferralParam({ param: 'ref', storageKey: 'circadia_ambassador_ref', attr: 'ambassador_ref' });
  captureReferralParam({ param: 'raf', storageKey: 'circadia_raf_ref', attr: 'raf_ref' });
})();
